/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TargetingRouteImport } from './routes/targeting'
import { Route as SupplyRouteImport } from './routes/supply'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ReportingRouteImport } from './routes/reporting'
import { Route as NetworksRouteImport } from './routes/networks'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as DesignSystemRouteImport } from './routes/design-system'
import { Route as DemandRouteImport } from './routes/demand'
import { Route as DebugRouteImport } from './routes/debug'
import { Route as CampaignsRouteImport } from './routes/campaigns'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as A2vRouteImport } from './routes/a2v'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TargetingIndexRouteImport } from './routes/targeting.index'
import { Route as SupplyIndexRouteImport } from './routes/supply.index'
import { Route as ReportingIndexRouteImport } from './routes/reporting.index'
import { Route as NetworksIndexRouteImport } from './routes/networks.index'
import { Route as DemandIndexRouteImport } from './routes/demand.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as A2vIndexRouteImport } from './routes/a2v.index'
import { Route as TargetingNewRouteImport } from './routes/targeting.new'
import { Route as SupplyTailoredSupplyRouteImport } from './routes/supply.tailored-supply'
import { Route as SupplyPublishersRouteImport } from './routes/supply.publishers'
import { Route as SupplyPlacementsRouteImport } from './routes/supply.placements'
import { Route as SupplyListsRouteImport } from './routes/supply.lists'
import { Route as SupplyEndpointGeneratorRouteImport } from './routes/supply.endpoint-generator'
import { Route as SupplyDomainsRouteImport } from './routes/supply.domains'
import { Route as SupplyBlockedListRouteImport } from './routes/supply.blocked-list'
import { Route as SupplyAppsRouteImport } from './routes/supply.apps'
import { Route as SupplyAdsTxtRouteImport } from './routes/supply.ads-txt'
import { Route as ReportingSavedReportsRouteImport } from './routes/reporting.saved-reports'
import { Route as ReportingReportExplorerRouteImport } from './routes/reporting.report-explorer'
import { Route as ReportingPerformanceAnalyzerRouteImport } from './routes/reporting.performance-analyzer'
import { Route as ReportingNetworkPerformanceRouteImport } from './routes/reporting.network-performance'
import { Route as PPublisherIdRouteImport } from './routes/p.$publisherId'
import { Route as NetworksCreateRouteImport } from './routes/networks.create'
import { Route as DemandPartnersRouteImport } from './routes/demand.partners'
import { Route as DemandOwnersRouteImport } from './routes/demand.owners'
import { Route as DemandIntegrationsRouteImport } from './routes/demand.integrations'
import { Route as DemandDealsRouteImport } from './routes/demand.deals'
import { Route as CampaignsCreativesRouteImport } from './routes/campaigns.creatives'
import { Route as CampaignsChannelGroupsRouteImport } from './routes/campaigns.channel-groups'
import { Route as CampaignsCampaignsRouteImport } from './routes/campaigns.campaigns'
import { Route as CampaignsBrandsRouteImport } from './routes/campaigns.brands'
import { Route as CampaignsAgenciesRouteImport } from './routes/campaigns.agencies'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminChangelogRouteImport } from './routes/admin.changelog'
import { Route as A2vNetworkTemplateRouteImport } from './routes/a2v.network-template'
import { Route as A2vAssetsRouteImport } from './routes/a2v.assets'
import { Route as AAgencyIdRouteImport } from './routes/a.$agencyId'
import { Route as SupplyTailoredSupplyIndexRouteImport } from './routes/supply.tailored-supply.index'
import { Route as SupplyListsIndexRouteImport } from './routes/supply.lists.index'
import { Route as SupplyBlockedListIndexRouteImport } from './routes/supply.blocked-list.index'
import { Route as SupplyAppsIndexRouteImport } from './routes/supply.apps.index'
import { Route as SupplyAdsTxtIndexRouteImport } from './routes/supply.ads-txt.index'
import { Route as DemandPartnersIndexRouteImport } from './routes/demand.partners.index'
import { Route as DemandOwnersIndexRouteImport } from './routes/demand.owners.index'
import { Route as DemandIntegrationsIndexRouteImport } from './routes/demand.integrations.index'
import { Route as DemandDealsIndexRouteImport } from './routes/demand.deals.index'
import { Route as TargetingTargetingIdEditRouteImport } from './routes/targeting.$targetingId.edit'
import { Route as SupplyTailoredSupplyCreateRouteImport } from './routes/supply.tailored-supply.create'
import { Route as SupplyPublishersCreateRouteImport } from './routes/supply.publishers_.create'
import { Route as SupplyListsSchainRouteImport } from './routes/supply.lists.schain'
import { Route as SupplyListsRewriteRouteImport } from './routes/supply.lists.rewrite'
import { Route as SupplyListsAllRouteImport } from './routes/supply.lists.all'
import { Route as SupplyBlockedListCreativesRouteImport } from './routes/supply.blocked-list.creatives'
import { Route as SupplyAppsRequestsRouteImport } from './routes/supply.apps.requests'
import { Route as SupplyAdsTxtRecordsRouteImport } from './routes/supply.ads-txt.records'
import { Route as SupplyAdsTxtDomainsRouteImport } from './routes/supply.ads-txt.domains'
import { Route as SupplyAdsTxtAppsRouteImport } from './routes/supply.ads-txt.apps'
import { Route as ReportingSavedReportsSharedRouteImport } from './routes/reporting.saved-reports_.shared'
import { Route as NetworksEditNetworkIdRouteImport } from './routes/networks.edit.$networkId'
import { Route as NetworksNetworkIdDetailsRouteImport } from './routes/networks.$networkId.details'
import { Route as DemandPartnersCreateRouteImport } from './routes/demand.partners.create'
import { Route as DemandOwnersCreateRouteImport } from './routes/demand.owners.create'
import { Route as DemandIntegrationsCreateRouteImport } from './routes/demand.integrations.create'
import { Route as DemandDealsCreateRouteImport } from './routes/demand.deals.create'
import { Route as CampaignsSupplyTailoredSupplyRouteImport } from './routes/campaigns.supply.tailored-supply'
import { Route as CampaignsSupplyDomainsRouteImport } from './routes/campaigns.supply.domains'
import { Route as CampaignsSupplyAppsRouteImport } from './routes/campaigns.supply.apps'
import { Route as CampaignsCreativesVideoRouteImport } from './routes/campaigns.creatives_.video'
import { Route as CampaignsCreativesDisplayRouteImport } from './routes/campaigns.creatives_.display'
import { Route as NetworksNetworkIdDetailsIndexRouteImport } from './routes/networks.$networkId.details.index'
import { Route as CampaignsSupplyTailoredSupplyIndexRouteImport } from './routes/campaigns.supply.tailored-supply.index'
import { Route as SupplyPublishersEditPublisherIdRouteImport } from './routes/supply.publishers_.edit.$publisherId'
import { Route as SupplyPublishersPublisherIdDetailsRouteImport } from './routes/supply.publishers_.$publisherId.details'
import { Route as SupplyPlacementsEditPlacementIdRouteImport } from './routes/supply.placements_.edit.$placementId'
import { Route as SupplyPlacementsCreatePlacementTypeRouteImport } from './routes/supply.placements_.create.$placementType'
import { Route as SupplyListsSchainCreateRouteImport } from './routes/supply.lists_.schain_.create'
import { Route as SupplyListsRewriteCreateRouteImport } from './routes/supply.lists_.rewrite_.create'
import { Route as SupplyAppsEditAppIdRouteImport } from './routes/supply.apps_.edit.$appId'
import { Route as PPublisherIdReportingReportExplorerRouteImport } from './routes/p.$publisherId_.reporting.report-explorer'
import { Route as NetworksNetworkIdDetailsOverviewRouteImport } from './routes/networks.$networkId.details.overview'
import { Route as DemandPartnersEditDemandPartnerIdRouteImport } from './routes/demand.partners.edit.$demandPartnerId'
import { Route as DemandPartnersDemandPartnerIdDetailsRouteImport } from './routes/demand.partners.$demandPartnerId.details'
import { Route as DemandOwnersEditOwnerIdRouteImport } from './routes/demand.owners.edit.$ownerId'
import { Route as DemandDealsEditDealIdRouteImport } from './routes/demand.deals.edit.$dealId'
import { Route as CampaignsSupplyTailoredSupplyCreateRouteImport } from './routes/campaigns.supply.tailored-supply.create'
import { Route as CampaignsCreativesVideoCreateRouteImport } from './routes/campaigns.creatives_.video_.create'
import { Route as CampaignsCreativesDisplayCreateRouteImport } from './routes/campaigns.creatives_.display_.create'
import { Route as CampaignsCampaignsOverviewCampaignIdRouteImport } from './routes/campaigns.campaigns_.overview.$campaignId'
import { Route as CampaignsBrandsBrandIdDetailsRouteImport } from './routes/campaigns.brands_.$brandId.details'
import { Route as CampaignsAgenciesAgencyIdDetailsRouteImport } from './routes/campaigns.agencies_.$agencyId.details'
import { Route as AAgencyIdReportingSavedReportsRouteImport } from './routes/a.$agencyId_.reporting.saved-reports'
import { Route as AAgencyIdReportingReportExplorerRouteImport } from './routes/a.$agencyId_.reporting.report-explorer'
import { Route as AAgencyIdCampaignsOverviewRouteImport } from './routes/a.$agencyId_.campaigns.overview'
import { Route as AAgencyIdCampaignsSectionRouteImport } from './routes/a.$agencyId_.campaigns.$section'
import { Route as SupplyPublishersPublisherIdDetailsIndexRouteImport } from './routes/supply.publishers_.$publisherId.details.index'
import { Route as DemandPartnersDemandPartnerIdDetailsIndexRouteImport } from './routes/demand.partners.$demandPartnerId.details.index'
import { Route as SupplyPublishersPublisherIdDetailsPlacementsRouteImport } from './routes/supply.publishers_.$publisherId.details.placements'
import { Route as SupplyPublishersPublisherIdDetailsOverviewRouteImport } from './routes/supply.publishers_.$publisherId.details.overview'
import { Route as SupplyPublishersPublisherIdDetailsDomainsRouteImport } from './routes/supply.publishers_.$publisherId.details.domains'
import { Route as SupplyPublishersPublisherIdDetailsAppsRouteImport } from './routes/supply.publishers_.$publisherId.details.apps'
import { Route as SupplyPublishersPublisherIdDetailsAppRequestsRouteImport } from './routes/supply.publishers_.$publisherId.details.app-requests'
import { Route as SupplyPublishersPublisherIdDetailsA2vRouteImport } from './routes/supply.publishers_.$publisherId.details.a2v'
import { Route as SupplyListsSchainEditListIdRouteImport } from './routes/supply.lists_.schain_.edit.$listId'
import { Route as SupplyListsRewriteEditListIdRouteImport } from './routes/supply.lists_.rewrite_.edit.$listId'
import { Route as DemandPartnersDemandPartnerIdDetailsOverviewRouteImport } from './routes/demand.partners.$demandPartnerId.details.overview'
import { Route as DemandIntegrationsEditDemandPartnerIdIntegrationIdRouteImport } from './routes/demand.integrations.edit.$demandPartnerId.$integrationId'
import { Route as CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRouteImport } from './routes/campaigns.supply.tailored-supply.edit.$tailoredSupplyId'
import { Route as CampaignsCreativesVideoEditCreativeIdRouteImport } from './routes/campaigns.creatives_.video_.edit.$creativeId'
import { Route as CampaignsCreativesDisplayEditCreativeIdRouteImport } from './routes/campaigns.creatives_.display_.edit.$creativeId'
import { Route as DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteImport } from './routes/demand.integrations.$integrationId.demand.$demandPartnerId.details'
import { Route as CampaignsCampaignsOverviewCampaignIdLineItemsCreateRouteImport } from './routes/campaigns.campaigns_.overview.$campaignId_.line-items.create'
import { Route as AAgencyIdCampaignsBrandsBrandIdDetailsRouteImport } from './routes/a.$agencyId_.campaigns.brands.$brandId.details'
import { Route as DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRouteImport } from './routes/demand.integrations.$integrationId.demand.$demandPartnerId.details.index'
import { Route as DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRouteImport } from './routes/demand.integrations.$integrationId.demand.$demandPartnerId.details.placements'
import { Route as DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRouteImport } from './routes/demand.integrations.$integrationId.demand.$demandPartnerId.details.overview'
import { Route as DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRouteImport } from './routes/demand.integrations.$integrationId.demand.$demandPartnerId.details.journey'
import { Route as CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRouteImport } from './routes/campaigns.campaigns_.overview.$campaignId_.line-items.edit.$lineItemId'

const TargetingRoute = TargetingRouteImport.update({
  id: '/targeting',
  path: '/targeting',
  getParentRoute: () => rootRouteImport,
} as any)
const SupplyRoute = SupplyRouteImport.update({
  id: '/supply',
  path: '/supply',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportingRoute = ReportingRouteImport.update({
  id: '/reporting',
  path: '/reporting',
  getParentRoute: () => rootRouteImport,
} as any)
const NetworksRoute = NetworksRouteImport.update({
  id: '/networks',
  path: '/networks',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const DesignSystemRoute = DesignSystemRouteImport.update({
  id: '/design-system',
  path: '/design-system',
  getParentRoute: () => rootRouteImport,
} as any)
const DemandRoute = DemandRouteImport.update({
  id: '/demand',
  path: '/demand',
  getParentRoute: () => rootRouteImport,
} as any)
const DebugRoute = DebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsRoute = CampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const A2vRoute = A2vRouteImport.update({
  id: '/a2v',
  path: '/a2v',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TargetingIndexRoute = TargetingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TargetingRoute,
} as any)
const SupplyIndexRoute = SupplyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupplyRoute,
} as any)
const ReportingIndexRoute = ReportingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportingRoute,
} as any)
const NetworksIndexRoute = NetworksIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => NetworksRoute,
} as any)
const DemandIndexRoute = DemandIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemandRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const A2vIndexRoute = A2vIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => A2vRoute,
} as any)
const TargetingNewRoute = TargetingNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => TargetingRoute,
} as any)
const SupplyTailoredSupplyRoute = SupplyTailoredSupplyRouteImport.update({
  id: '/tailored-supply',
  path: '/tailored-supply',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyPublishersRoute = SupplyPublishersRouteImport.update({
  id: '/publishers',
  path: '/publishers',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyPlacementsRoute = SupplyPlacementsRouteImport.update({
  id: '/placements',
  path: '/placements',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyListsRoute = SupplyListsRouteImport.update({
  id: '/lists',
  path: '/lists',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyEndpointGeneratorRoute = SupplyEndpointGeneratorRouteImport.update({
  id: '/endpoint-generator',
  path: '/endpoint-generator',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyDomainsRoute = SupplyDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyBlockedListRoute = SupplyBlockedListRouteImport.update({
  id: '/blocked-list',
  path: '/blocked-list',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyAppsRoute = SupplyAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyAdsTxtRoute = SupplyAdsTxtRouteImport.update({
  id: '/ads-txt',
  path: '/ads-txt',
  getParentRoute: () => SupplyRoute,
} as any)
const ReportingSavedReportsRoute = ReportingSavedReportsRouteImport.update({
  id: '/saved-reports',
  path: '/saved-reports',
  getParentRoute: () => ReportingRoute,
} as any)
const ReportingReportExplorerRoute = ReportingReportExplorerRouteImport.update({
  id: '/report-explorer',
  path: '/report-explorer',
  getParentRoute: () => ReportingRoute,
} as any)
const ReportingPerformanceAnalyzerRoute =
  ReportingPerformanceAnalyzerRouteImport.update({
    id: '/performance-analyzer',
    path: '/performance-analyzer',
    getParentRoute: () => ReportingRoute,
  } as any)
const ReportingNetworkPerformanceRoute =
  ReportingNetworkPerformanceRouteImport.update({
    id: '/network-performance',
    path: '/network-performance',
    getParentRoute: () => ReportingRoute,
  } as any)
const PPublisherIdRoute = PPublisherIdRouteImport.update({
  id: '/p/$publisherId',
  path: '/p/$publisherId',
  getParentRoute: () => rootRouteImport,
} as any)
const NetworksCreateRoute = NetworksCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => NetworksRoute,
} as any)
const DemandPartnersRoute = DemandPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => DemandRoute,
} as any)
const DemandOwnersRoute = DemandOwnersRouteImport.update({
  id: '/owners',
  path: '/owners',
  getParentRoute: () => DemandRoute,
} as any)
const DemandIntegrationsRoute = DemandIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => DemandRoute,
} as any)
const DemandDealsRoute = DemandDealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => DemandRoute,
} as any)
const CampaignsCreativesRoute = CampaignsCreativesRouteImport.update({
  id: '/creatives',
  path: '/creatives',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsChannelGroupsRoute = CampaignsChannelGroupsRouteImport.update({
  id: '/channel-groups',
  path: '/channel-groups',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsCampaignsRoute = CampaignsCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsBrandsRoute = CampaignsBrandsRouteImport.update({
  id: '/brands',
  path: '/brands',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsAgenciesRoute = CampaignsAgenciesRouteImport.update({
  id: '/agencies',
  path: '/agencies',
  getParentRoute: () => CampaignsRoute,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminChangelogRoute = AdminChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => AdminRoute,
} as any)
const A2vNetworkTemplateRoute = A2vNetworkTemplateRouteImport.update({
  id: '/network-template',
  path: '/network-template',
  getParentRoute: () => A2vRoute,
} as any)
const A2vAssetsRoute = A2vAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => A2vRoute,
} as any)
const AAgencyIdRoute = AAgencyIdRouteImport.update({
  id: '/a/$agencyId',
  path: '/a/$agencyId',
  getParentRoute: () => rootRouteImport,
} as any)
const SupplyTailoredSupplyIndexRoute =
  SupplyTailoredSupplyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SupplyTailoredSupplyRoute,
  } as any)
const SupplyListsIndexRoute = SupplyListsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupplyListsRoute,
} as any)
const SupplyBlockedListIndexRoute = SupplyBlockedListIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupplyBlockedListRoute,
} as any)
const SupplyAppsIndexRoute = SupplyAppsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupplyAppsRoute,
} as any)
const SupplyAdsTxtIndexRoute = SupplyAdsTxtIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupplyAdsTxtRoute,
} as any)
const DemandPartnersIndexRoute = DemandPartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemandPartnersRoute,
} as any)
const DemandOwnersIndexRoute = DemandOwnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemandOwnersRoute,
} as any)
const DemandIntegrationsIndexRoute = DemandIntegrationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemandIntegrationsRoute,
} as any)
const DemandDealsIndexRoute = DemandDealsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DemandDealsRoute,
} as any)
const TargetingTargetingIdEditRoute =
  TargetingTargetingIdEditRouteImport.update({
    id: '/$targetingId/edit',
    path: '/$targetingId/edit',
    getParentRoute: () => TargetingRoute,
  } as any)
const SupplyTailoredSupplyCreateRoute =
  SupplyTailoredSupplyCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => SupplyTailoredSupplyRoute,
  } as any)
const SupplyPublishersCreateRoute = SupplyPublishersCreateRouteImport.update({
  id: '/publishers_/create',
  path: '/publishers/create',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyListsSchainRoute = SupplyListsSchainRouteImport.update({
  id: '/schain',
  path: '/schain',
  getParentRoute: () => SupplyListsRoute,
} as any)
const SupplyListsRewriteRoute = SupplyListsRewriteRouteImport.update({
  id: '/rewrite',
  path: '/rewrite',
  getParentRoute: () => SupplyListsRoute,
} as any)
const SupplyListsAllRoute = SupplyListsAllRouteImport.update({
  id: '/all',
  path: '/all',
  getParentRoute: () => SupplyListsRoute,
} as any)
const SupplyBlockedListCreativesRoute =
  SupplyBlockedListCreativesRouteImport.update({
    id: '/creatives',
    path: '/creatives',
    getParentRoute: () => SupplyBlockedListRoute,
  } as any)
const SupplyAppsRequestsRoute = SupplyAppsRequestsRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => SupplyAppsRoute,
} as any)
const SupplyAdsTxtRecordsRoute = SupplyAdsTxtRecordsRouteImport.update({
  id: '/records',
  path: '/records',
  getParentRoute: () => SupplyAdsTxtRoute,
} as any)
const SupplyAdsTxtDomainsRoute = SupplyAdsTxtDomainsRouteImport.update({
  id: '/domains',
  path: '/domains',
  getParentRoute: () => SupplyAdsTxtRoute,
} as any)
const SupplyAdsTxtAppsRoute = SupplyAdsTxtAppsRouteImport.update({
  id: '/apps',
  path: '/apps',
  getParentRoute: () => SupplyAdsTxtRoute,
} as any)
const ReportingSavedReportsSharedRoute =
  ReportingSavedReportsSharedRouteImport.update({
    id: '/saved-reports_/shared',
    path: '/saved-reports/shared',
    getParentRoute: () => ReportingRoute,
  } as any)
const NetworksEditNetworkIdRoute = NetworksEditNetworkIdRouteImport.update({
  id: '/edit/$networkId',
  path: '/edit/$networkId',
  getParentRoute: () => NetworksRoute,
} as any)
const NetworksNetworkIdDetailsRoute =
  NetworksNetworkIdDetailsRouteImport.update({
    id: '/$networkId/details',
    path: '/$networkId/details',
    getParentRoute: () => NetworksRoute,
  } as any)
const DemandPartnersCreateRoute = DemandPartnersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => DemandPartnersRoute,
} as any)
const DemandOwnersCreateRoute = DemandOwnersCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => DemandOwnersRoute,
} as any)
const DemandIntegrationsCreateRoute =
  DemandIntegrationsCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => DemandIntegrationsRoute,
  } as any)
const DemandDealsCreateRoute = DemandDealsCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => DemandDealsRoute,
} as any)
const CampaignsSupplyTailoredSupplyRoute =
  CampaignsSupplyTailoredSupplyRouteImport.update({
    id: '/supply/tailored-supply',
    path: '/supply/tailored-supply',
    getParentRoute: () => CampaignsRoute,
  } as any)
const CampaignsSupplyDomainsRoute = CampaignsSupplyDomainsRouteImport.update({
  id: '/supply/domains',
  path: '/supply/domains',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsSupplyAppsRoute = CampaignsSupplyAppsRouteImport.update({
  id: '/supply/apps',
  path: '/supply/apps',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsCreativesVideoRoute = CampaignsCreativesVideoRouteImport.update({
  id: '/creatives_/video',
  path: '/creatives/video',
  getParentRoute: () => CampaignsRoute,
} as any)
const CampaignsCreativesDisplayRoute =
  CampaignsCreativesDisplayRouteImport.update({
    id: '/creatives_/display',
    path: '/creatives/display',
    getParentRoute: () => CampaignsRoute,
  } as any)
const NetworksNetworkIdDetailsIndexRoute =
  NetworksNetworkIdDetailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => NetworksNetworkIdDetailsRoute,
  } as any)
const CampaignsSupplyTailoredSupplyIndexRoute =
  CampaignsSupplyTailoredSupplyIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => CampaignsSupplyTailoredSupplyRoute,
  } as any)
const SupplyPublishersEditPublisherIdRoute =
  SupplyPublishersEditPublisherIdRouteImport.update({
    id: '/publishers_/edit/$publisherId',
    path: '/publishers/edit/$publisherId',
    getParentRoute: () => SupplyRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsRoute =
  SupplyPublishersPublisherIdDetailsRouteImport.update({
    id: '/publishers_/$publisherId/details',
    path: '/publishers/$publisherId/details',
    getParentRoute: () => SupplyRoute,
  } as any)
const SupplyPlacementsEditPlacementIdRoute =
  SupplyPlacementsEditPlacementIdRouteImport.update({
    id: '/placements_/edit/$placementId',
    path: '/placements/edit/$placementId',
    getParentRoute: () => SupplyRoute,
  } as any)
const SupplyPlacementsCreatePlacementTypeRoute =
  SupplyPlacementsCreatePlacementTypeRouteImport.update({
    id: '/placements_/create/$placementType',
    path: '/placements/create/$placementType',
    getParentRoute: () => SupplyRoute,
  } as any)
const SupplyListsSchainCreateRoute = SupplyListsSchainCreateRouteImport.update({
  id: '/lists_/schain_/create',
  path: '/lists/schain/create',
  getParentRoute: () => SupplyRoute,
} as any)
const SupplyListsRewriteCreateRoute =
  SupplyListsRewriteCreateRouteImport.update({
    id: '/lists_/rewrite_/create',
    path: '/lists/rewrite/create',
    getParentRoute: () => SupplyRoute,
  } as any)
const SupplyAppsEditAppIdRoute = SupplyAppsEditAppIdRouteImport.update({
  id: '/apps_/edit/$appId',
  path: '/apps/edit/$appId',
  getParentRoute: () => SupplyRoute,
} as any)
const PPublisherIdReportingReportExplorerRoute =
  PPublisherIdReportingReportExplorerRouteImport.update({
    id: '/p/$publisherId_/reporting/report-explorer',
    path: '/p/$publisherId/reporting/report-explorer',
    getParentRoute: () => rootRouteImport,
  } as any)
const NetworksNetworkIdDetailsOverviewRoute =
  NetworksNetworkIdDetailsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => NetworksNetworkIdDetailsRoute,
  } as any)
const DemandPartnersEditDemandPartnerIdRoute =
  DemandPartnersEditDemandPartnerIdRouteImport.update({
    id: '/edit/$demandPartnerId',
    path: '/edit/$demandPartnerId',
    getParentRoute: () => DemandPartnersRoute,
  } as any)
const DemandPartnersDemandPartnerIdDetailsRoute =
  DemandPartnersDemandPartnerIdDetailsRouteImport.update({
    id: '/$demandPartnerId/details',
    path: '/$demandPartnerId/details',
    getParentRoute: () => DemandPartnersRoute,
  } as any)
const DemandOwnersEditOwnerIdRoute = DemandOwnersEditOwnerIdRouteImport.update({
  id: '/edit/$ownerId',
  path: '/edit/$ownerId',
  getParentRoute: () => DemandOwnersRoute,
} as any)
const DemandDealsEditDealIdRoute = DemandDealsEditDealIdRouteImport.update({
  id: '/edit/$dealId',
  path: '/edit/$dealId',
  getParentRoute: () => DemandDealsRoute,
} as any)
const CampaignsSupplyTailoredSupplyCreateRoute =
  CampaignsSupplyTailoredSupplyCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => CampaignsSupplyTailoredSupplyRoute,
  } as any)
const CampaignsCreativesVideoCreateRoute =
  CampaignsCreativesVideoCreateRouteImport.update({
    id: '/creatives_/video_/create',
    path: '/creatives/video/create',
    getParentRoute: () => CampaignsRoute,
  } as any)
const CampaignsCreativesDisplayCreateRoute =
  CampaignsCreativesDisplayCreateRouteImport.update({
    id: '/creatives_/display_/create',
    path: '/creatives/display/create',
    getParentRoute: () => CampaignsRoute,
  } as any)
const CampaignsCampaignsOverviewCampaignIdRoute =
  CampaignsCampaignsOverviewCampaignIdRouteImport.update({
    id: '/campaigns_/overview/$campaignId',
    path: '/campaigns/overview/$campaignId',
    getParentRoute: () => CampaignsRoute,
  } as any)
const CampaignsBrandsBrandIdDetailsRoute =
  CampaignsBrandsBrandIdDetailsRouteImport.update({
    id: '/brands_/$brandId/details',
    path: '/brands/$brandId/details',
    getParentRoute: () => CampaignsRoute,
  } as any)
const CampaignsAgenciesAgencyIdDetailsRoute =
  CampaignsAgenciesAgencyIdDetailsRouteImport.update({
    id: '/agencies_/$agencyId/details',
    path: '/agencies/$agencyId/details',
    getParentRoute: () => CampaignsRoute,
  } as any)
const AAgencyIdReportingSavedReportsRoute =
  AAgencyIdReportingSavedReportsRouteImport.update({
    id: '/a/$agencyId_/reporting/saved-reports',
    path: '/a/$agencyId/reporting/saved-reports',
    getParentRoute: () => rootRouteImport,
  } as any)
const AAgencyIdReportingReportExplorerRoute =
  AAgencyIdReportingReportExplorerRouteImport.update({
    id: '/a/$agencyId_/reporting/report-explorer',
    path: '/a/$agencyId/reporting/report-explorer',
    getParentRoute: () => rootRouteImport,
  } as any)
const AAgencyIdCampaignsOverviewRoute =
  AAgencyIdCampaignsOverviewRouteImport.update({
    id: '/a/$agencyId_/campaigns/overview',
    path: '/a/$agencyId/campaigns/overview',
    getParentRoute: () => rootRouteImport,
  } as any)
const AAgencyIdCampaignsSectionRoute =
  AAgencyIdCampaignsSectionRouteImport.update({
    id: '/a/$agencyId_/campaigns/$section',
    path: '/a/$agencyId/campaigns/$section',
    getParentRoute: () => rootRouteImport,
  } as any)
const SupplyPublishersPublisherIdDetailsIndexRoute =
  SupplyPublishersPublisherIdDetailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const DemandPartnersDemandPartnerIdDetailsIndexRoute =
  DemandPartnersDemandPartnerIdDetailsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DemandPartnersDemandPartnerIdDetailsRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsPlacementsRoute =
  SupplyPublishersPublisherIdDetailsPlacementsRouteImport.update({
    id: '/placements',
    path: '/placements',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsOverviewRoute =
  SupplyPublishersPublisherIdDetailsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsDomainsRoute =
  SupplyPublishersPublisherIdDetailsDomainsRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsAppsRoute =
  SupplyPublishersPublisherIdDetailsAppsRouteImport.update({
    id: '/apps',
    path: '/apps',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsAppRequestsRoute =
  SupplyPublishersPublisherIdDetailsAppRequestsRouteImport.update({
    id: '/app-requests',
    path: '/app-requests',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const SupplyPublishersPublisherIdDetailsA2vRoute =
  SupplyPublishersPublisherIdDetailsA2vRouteImport.update({
    id: '/a2v',
    path: '/a2v',
    getParentRoute: () => SupplyPublishersPublisherIdDetailsRoute,
  } as any)
const SupplyListsSchainEditListIdRoute =
  SupplyListsSchainEditListIdRouteImport.update({
    id: '/lists_/schain_/edit/$listId',
    path: '/lists/schain/edit/$listId',
    getParentRoute: () => SupplyRoute,
  } as any)
const SupplyListsRewriteEditListIdRoute =
  SupplyListsRewriteEditListIdRouteImport.update({
    id: '/lists_/rewrite_/edit/$listId',
    path: '/lists/rewrite/edit/$listId',
    getParentRoute: () => SupplyRoute,
  } as any)
const DemandPartnersDemandPartnerIdDetailsOverviewRoute =
  DemandPartnersDemandPartnerIdDetailsOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DemandPartnersDemandPartnerIdDetailsRoute,
  } as any)
const DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute =
  DemandIntegrationsEditDemandPartnerIdIntegrationIdRouteImport.update({
    id: '/edit/$demandPartnerId/$integrationId',
    path: '/edit/$demandPartnerId/$integrationId',
    getParentRoute: () => DemandIntegrationsRoute,
  } as any)
const CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute =
  CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRouteImport.update({
    id: '/edit/$tailoredSupplyId',
    path: '/edit/$tailoredSupplyId',
    getParentRoute: () => CampaignsSupplyTailoredSupplyRoute,
  } as any)
const CampaignsCreativesVideoEditCreativeIdRoute =
  CampaignsCreativesVideoEditCreativeIdRouteImport.update({
    id: '/creatives_/video_/edit/$creativeId',
    path: '/creatives/video/edit/$creativeId',
    getParentRoute: () => CampaignsRoute,
  } as any)
const CampaignsCreativesDisplayEditCreativeIdRoute =
  CampaignsCreativesDisplayEditCreativeIdRouteImport.update({
    id: '/creatives_/display_/edit/$creativeId',
    path: '/creatives/display/edit/$creativeId',
    getParentRoute: () => CampaignsRoute,
  } as any)
const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute =
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteImport.update(
    {
      id: '/$integrationId/demand/$demandPartnerId/details',
      path: '/$integrationId/demand/$demandPartnerId/details',
      getParentRoute: () => DemandIntegrationsRoute,
    } as any,
  )
const CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute =
  CampaignsCampaignsOverviewCampaignIdLineItemsCreateRouteImport.update({
    id: '/campaigns_/overview/$campaignId_/line-items/create',
    path: '/campaigns/overview/$campaignId/line-items/create',
    getParentRoute: () => CampaignsRoute,
  } as any)
const AAgencyIdCampaignsBrandsBrandIdDetailsRoute =
  AAgencyIdCampaignsBrandsBrandIdDetailsRouteImport.update({
    id: '/a/$agencyId_/campaigns/brands/$brandId/details',
    path: '/a/$agencyId/campaigns/brands/$brandId/details',
    getParentRoute: () => rootRouteImport,
  } as any)
const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute =
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute,
    } as any,
  )
const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute =
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRouteImport.update(
    {
      id: '/placements',
      path: '/placements',
      getParentRoute: () =>
        DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute,
    } as any,
  )
const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute =
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRouteImport.update(
    {
      id: '/overview',
      path: '/overview',
      getParentRoute: () =>
        DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute,
    } as any,
  )
const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute =
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRouteImport.update(
    {
      id: '/journey',
      path: '/journey',
      getParentRoute: () =>
        DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute,
    } as any,
  )
const CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute =
  CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRouteImport.update(
    {
      id: '/campaigns_/overview/$campaignId_/line-items/edit/$lineItemId',
      path: '/campaigns/overview/$campaignId/line-items/edit/$lineItemId',
      getParentRoute: () => CampaignsRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/a2v': typeof A2vRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/debug': typeof DebugRoute
  '/demand': typeof DemandRouteWithChildren
  '/design-system': typeof DesignSystemRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/networks': typeof NetworksRouteWithChildren
  '/reporting': typeof ReportingRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/supply': typeof SupplyRouteWithChildren
  '/targeting': typeof TargetingRouteWithChildren
  '/a/$agencyId': typeof AAgencyIdRoute
  '/a2v/assets': typeof A2vAssetsRoute
  '/a2v/network-template': typeof A2vNetworkTemplateRoute
  '/admin/changelog': typeof AdminChangelogRoute
  '/admin/users': typeof AdminUsersRoute
  '/campaigns/agencies': typeof CampaignsAgenciesRoute
  '/campaigns/brands': typeof CampaignsBrandsRoute
  '/campaigns/campaigns': typeof CampaignsCampaignsRoute
  '/campaigns/channel-groups': typeof CampaignsChannelGroupsRoute
  '/campaigns/creatives': typeof CampaignsCreativesRoute
  '/demand/deals': typeof DemandDealsRouteWithChildren
  '/demand/integrations': typeof DemandIntegrationsRouteWithChildren
  '/demand/owners': typeof DemandOwnersRouteWithChildren
  '/demand/partners': typeof DemandPartnersRouteWithChildren
  '/networks/create': typeof NetworksCreateRoute
  '/p/$publisherId': typeof PPublisherIdRoute
  '/reporting/network-performance': typeof ReportingNetworkPerformanceRoute
  '/reporting/performance-analyzer': typeof ReportingPerformanceAnalyzerRoute
  '/reporting/report-explorer': typeof ReportingReportExplorerRoute
  '/reporting/saved-reports': typeof ReportingSavedReportsRoute
  '/supply/ads-txt': typeof SupplyAdsTxtRouteWithChildren
  '/supply/apps': typeof SupplyAppsRouteWithChildren
  '/supply/blocked-list': typeof SupplyBlockedListRouteWithChildren
  '/supply/domains': typeof SupplyDomainsRoute
  '/supply/endpoint-generator': typeof SupplyEndpointGeneratorRoute
  '/supply/lists': typeof SupplyListsRouteWithChildren
  '/supply/placements': typeof SupplyPlacementsRoute
  '/supply/publishers': typeof SupplyPublishersRoute
  '/supply/tailored-supply': typeof SupplyTailoredSupplyRouteWithChildren
  '/targeting/new': typeof TargetingNewRoute
  '/a2v/': typeof A2vIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/demand/': typeof DemandIndexRoute
  '/networks/': typeof NetworksIndexRoute
  '/reporting/': typeof ReportingIndexRoute
  '/supply/': typeof SupplyIndexRoute
  '/targeting/': typeof TargetingIndexRoute
  '/campaigns/creatives/display': typeof CampaignsCreativesDisplayRoute
  '/campaigns/creatives/video': typeof CampaignsCreativesVideoRoute
  '/campaigns/supply/apps': typeof CampaignsSupplyAppsRoute
  '/campaigns/supply/domains': typeof CampaignsSupplyDomainsRoute
  '/campaigns/supply/tailored-supply': typeof CampaignsSupplyTailoredSupplyRouteWithChildren
  '/demand/deals/create': typeof DemandDealsCreateRoute
  '/demand/integrations/create': typeof DemandIntegrationsCreateRoute
  '/demand/owners/create': typeof DemandOwnersCreateRoute
  '/demand/partners/create': typeof DemandPartnersCreateRoute
  '/networks/$networkId/details': typeof NetworksNetworkIdDetailsRouteWithChildren
  '/networks/edit/$networkId': typeof NetworksEditNetworkIdRoute
  '/reporting/saved-reports/shared': typeof ReportingSavedReportsSharedRoute
  '/supply/ads-txt/apps': typeof SupplyAdsTxtAppsRoute
  '/supply/ads-txt/domains': typeof SupplyAdsTxtDomainsRoute
  '/supply/ads-txt/records': typeof SupplyAdsTxtRecordsRoute
  '/supply/apps/requests': typeof SupplyAppsRequestsRoute
  '/supply/blocked-list/creatives': typeof SupplyBlockedListCreativesRoute
  '/supply/lists/all': typeof SupplyListsAllRoute
  '/supply/lists/rewrite': typeof SupplyListsRewriteRoute
  '/supply/lists/schain': typeof SupplyListsSchainRoute
  '/supply/publishers/create': typeof SupplyPublishersCreateRoute
  '/supply/tailored-supply/create': typeof SupplyTailoredSupplyCreateRoute
  '/targeting/$targetingId/edit': typeof TargetingTargetingIdEditRoute
  '/demand/deals/': typeof DemandDealsIndexRoute
  '/demand/integrations/': typeof DemandIntegrationsIndexRoute
  '/demand/owners/': typeof DemandOwnersIndexRoute
  '/demand/partners/': typeof DemandPartnersIndexRoute
  '/supply/ads-txt/': typeof SupplyAdsTxtIndexRoute
  '/supply/apps/': typeof SupplyAppsIndexRoute
  '/supply/blocked-list/': typeof SupplyBlockedListIndexRoute
  '/supply/lists/': typeof SupplyListsIndexRoute
  '/supply/tailored-supply/': typeof SupplyTailoredSupplyIndexRoute
  '/a/$agencyId/campaigns/$section': typeof AAgencyIdCampaignsSectionRoute
  '/a/$agencyId/campaigns/overview': typeof AAgencyIdCampaignsOverviewRoute
  '/a/$agencyId/reporting/report-explorer': typeof AAgencyIdReportingReportExplorerRoute
  '/a/$agencyId/reporting/saved-reports': typeof AAgencyIdReportingSavedReportsRoute
  '/campaigns/agencies/$agencyId/details': typeof CampaignsAgenciesAgencyIdDetailsRoute
  '/campaigns/brands/$brandId/details': typeof CampaignsBrandsBrandIdDetailsRoute
  '/campaigns/campaigns/overview/$campaignId': typeof CampaignsCampaignsOverviewCampaignIdRoute
  '/campaigns/creatives/display/create': typeof CampaignsCreativesDisplayCreateRoute
  '/campaigns/creatives/video/create': typeof CampaignsCreativesVideoCreateRoute
  '/campaigns/supply/tailored-supply/create': typeof CampaignsSupplyTailoredSupplyCreateRoute
  '/demand/deals/edit/$dealId': typeof DemandDealsEditDealIdRoute
  '/demand/owners/edit/$ownerId': typeof DemandOwnersEditOwnerIdRoute
  '/demand/partners/$demandPartnerId/details': typeof DemandPartnersDemandPartnerIdDetailsRouteWithChildren
  '/demand/partners/edit/$demandPartnerId': typeof DemandPartnersEditDemandPartnerIdRoute
  '/networks/$networkId/details/overview': typeof NetworksNetworkIdDetailsOverviewRoute
  '/p/$publisherId/reporting/report-explorer': typeof PPublisherIdReportingReportExplorerRoute
  '/supply/apps/edit/$appId': typeof SupplyAppsEditAppIdRoute
  '/supply/lists/rewrite/create': typeof SupplyListsRewriteCreateRoute
  '/supply/lists/schain/create': typeof SupplyListsSchainCreateRoute
  '/supply/placements/create/$placementType': typeof SupplyPlacementsCreatePlacementTypeRoute
  '/supply/placements/edit/$placementId': typeof SupplyPlacementsEditPlacementIdRoute
  '/supply/publishers/$publisherId/details': typeof SupplyPublishersPublisherIdDetailsRouteWithChildren
  '/supply/publishers/edit/$publisherId': typeof SupplyPublishersEditPublisherIdRoute
  '/campaigns/supply/tailored-supply/': typeof CampaignsSupplyTailoredSupplyIndexRoute
  '/networks/$networkId/details/': typeof NetworksNetworkIdDetailsIndexRoute
  '/campaigns/creatives/display/edit/$creativeId': typeof CampaignsCreativesDisplayEditCreativeIdRoute
  '/campaigns/creatives/video/edit/$creativeId': typeof CampaignsCreativesVideoEditCreativeIdRoute
  '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId': typeof CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute
  '/demand/integrations/edit/$demandPartnerId/$integrationId': typeof DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute
  '/demand/partners/$demandPartnerId/details/overview': typeof DemandPartnersDemandPartnerIdDetailsOverviewRoute
  '/supply/lists/rewrite/edit/$listId': typeof SupplyListsRewriteEditListIdRoute
  '/supply/lists/schain/edit/$listId': typeof SupplyListsSchainEditListIdRoute
  '/supply/publishers/$publisherId/details/a2v': typeof SupplyPublishersPublisherIdDetailsA2vRoute
  '/supply/publishers/$publisherId/details/app-requests': typeof SupplyPublishersPublisherIdDetailsAppRequestsRoute
  '/supply/publishers/$publisherId/details/apps': typeof SupplyPublishersPublisherIdDetailsAppsRoute
  '/supply/publishers/$publisherId/details/domains': typeof SupplyPublishersPublisherIdDetailsDomainsRoute
  '/supply/publishers/$publisherId/details/overview': typeof SupplyPublishersPublisherIdDetailsOverviewRoute
  '/supply/publishers/$publisherId/details/placements': typeof SupplyPublishersPublisherIdDetailsPlacementsRoute
  '/demand/partners/$demandPartnerId/details/': typeof DemandPartnersDemandPartnerIdDetailsIndexRoute
  '/supply/publishers/$publisherId/details/': typeof SupplyPublishersPublisherIdDetailsIndexRoute
  '/a/$agencyId/campaigns/brands/$brandId/details': typeof AAgencyIdCampaignsBrandsBrandIdDetailsRoute
  '/campaigns/campaigns/overview/$campaignId/line-items/create': typeof CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteWithChildren
  '/campaigns/campaigns/overview/$campaignId/line-items/edit/$lineItemId': typeof CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/campaigns': typeof CampaignsRouteWithChildren
  '/debug': typeof DebugRoute
  '/design-system': typeof DesignSystemRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/reset-password': typeof ResetPasswordRoute
  '/a/$agencyId': typeof AAgencyIdRoute
  '/a2v/assets': typeof A2vAssetsRoute
  '/a2v/network-template': typeof A2vNetworkTemplateRoute
  '/admin/changelog': typeof AdminChangelogRoute
  '/admin/users': typeof AdminUsersRoute
  '/campaigns/agencies': typeof CampaignsAgenciesRoute
  '/campaigns/brands': typeof CampaignsBrandsRoute
  '/campaigns/campaigns': typeof CampaignsCampaignsRoute
  '/campaigns/channel-groups': typeof CampaignsChannelGroupsRoute
  '/campaigns/creatives': typeof CampaignsCreativesRoute
  '/networks/create': typeof NetworksCreateRoute
  '/p/$publisherId': typeof PPublisherIdRoute
  '/reporting/network-performance': typeof ReportingNetworkPerformanceRoute
  '/reporting/performance-analyzer': typeof ReportingPerformanceAnalyzerRoute
  '/reporting/report-explorer': typeof ReportingReportExplorerRoute
  '/reporting/saved-reports': typeof ReportingSavedReportsRoute
  '/supply/domains': typeof SupplyDomainsRoute
  '/supply/endpoint-generator': typeof SupplyEndpointGeneratorRoute
  '/supply/placements': typeof SupplyPlacementsRoute
  '/supply/publishers': typeof SupplyPublishersRoute
  '/targeting/new': typeof TargetingNewRoute
  '/a2v': typeof A2vIndexRoute
  '/admin': typeof AdminIndexRoute
  '/demand': typeof DemandIndexRoute
  '/networks': typeof NetworksIndexRoute
  '/reporting': typeof ReportingIndexRoute
  '/supply': typeof SupplyIndexRoute
  '/targeting': typeof TargetingIndexRoute
  '/campaigns/creatives/display': typeof CampaignsCreativesDisplayRoute
  '/campaigns/creatives/video': typeof CampaignsCreativesVideoRoute
  '/campaigns/supply/apps': typeof CampaignsSupplyAppsRoute
  '/campaigns/supply/domains': typeof CampaignsSupplyDomainsRoute
  '/demand/deals/create': typeof DemandDealsCreateRoute
  '/demand/integrations/create': typeof DemandIntegrationsCreateRoute
  '/demand/owners/create': typeof DemandOwnersCreateRoute
  '/demand/partners/create': typeof DemandPartnersCreateRoute
  '/networks/edit/$networkId': typeof NetworksEditNetworkIdRoute
  '/reporting/saved-reports/shared': typeof ReportingSavedReportsSharedRoute
  '/supply/ads-txt/apps': typeof SupplyAdsTxtAppsRoute
  '/supply/ads-txt/domains': typeof SupplyAdsTxtDomainsRoute
  '/supply/ads-txt/records': typeof SupplyAdsTxtRecordsRoute
  '/supply/apps/requests': typeof SupplyAppsRequestsRoute
  '/supply/blocked-list/creatives': typeof SupplyBlockedListCreativesRoute
  '/supply/lists/all': typeof SupplyListsAllRoute
  '/supply/lists/rewrite': typeof SupplyListsRewriteRoute
  '/supply/lists/schain': typeof SupplyListsSchainRoute
  '/supply/publishers/create': typeof SupplyPublishersCreateRoute
  '/supply/tailored-supply/create': typeof SupplyTailoredSupplyCreateRoute
  '/targeting/$targetingId/edit': typeof TargetingTargetingIdEditRoute
  '/demand/deals': typeof DemandDealsIndexRoute
  '/demand/integrations': typeof DemandIntegrationsIndexRoute
  '/demand/owners': typeof DemandOwnersIndexRoute
  '/demand/partners': typeof DemandPartnersIndexRoute
  '/supply/ads-txt': typeof SupplyAdsTxtIndexRoute
  '/supply/apps': typeof SupplyAppsIndexRoute
  '/supply/blocked-list': typeof SupplyBlockedListIndexRoute
  '/supply/lists': typeof SupplyListsIndexRoute
  '/supply/tailored-supply': typeof SupplyTailoredSupplyIndexRoute
  '/a/$agencyId/campaigns/$section': typeof AAgencyIdCampaignsSectionRoute
  '/a/$agencyId/campaigns/overview': typeof AAgencyIdCampaignsOverviewRoute
  '/a/$agencyId/reporting/report-explorer': typeof AAgencyIdReportingReportExplorerRoute
  '/a/$agencyId/reporting/saved-reports': typeof AAgencyIdReportingSavedReportsRoute
  '/campaigns/agencies/$agencyId/details': typeof CampaignsAgenciesAgencyIdDetailsRoute
  '/campaigns/brands/$brandId/details': typeof CampaignsBrandsBrandIdDetailsRoute
  '/campaigns/campaigns/overview/$campaignId': typeof CampaignsCampaignsOverviewCampaignIdRoute
  '/campaigns/creatives/display/create': typeof CampaignsCreativesDisplayCreateRoute
  '/campaigns/creatives/video/create': typeof CampaignsCreativesVideoCreateRoute
  '/campaigns/supply/tailored-supply/create': typeof CampaignsSupplyTailoredSupplyCreateRoute
  '/demand/deals/edit/$dealId': typeof DemandDealsEditDealIdRoute
  '/demand/owners/edit/$ownerId': typeof DemandOwnersEditOwnerIdRoute
  '/demand/partners/edit/$demandPartnerId': typeof DemandPartnersEditDemandPartnerIdRoute
  '/networks/$networkId/details/overview': typeof NetworksNetworkIdDetailsOverviewRoute
  '/p/$publisherId/reporting/report-explorer': typeof PPublisherIdReportingReportExplorerRoute
  '/supply/apps/edit/$appId': typeof SupplyAppsEditAppIdRoute
  '/supply/lists/rewrite/create': typeof SupplyListsRewriteCreateRoute
  '/supply/lists/schain/create': typeof SupplyListsSchainCreateRoute
  '/supply/placements/create/$placementType': typeof SupplyPlacementsCreatePlacementTypeRoute
  '/supply/placements/edit/$placementId': typeof SupplyPlacementsEditPlacementIdRoute
  '/supply/publishers/edit/$publisherId': typeof SupplyPublishersEditPublisherIdRoute
  '/campaigns/supply/tailored-supply': typeof CampaignsSupplyTailoredSupplyIndexRoute
  '/networks/$networkId/details': typeof NetworksNetworkIdDetailsIndexRoute
  '/campaigns/creatives/display/edit/$creativeId': typeof CampaignsCreativesDisplayEditCreativeIdRoute
  '/campaigns/creatives/video/edit/$creativeId': typeof CampaignsCreativesVideoEditCreativeIdRoute
  '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId': typeof CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute
  '/demand/integrations/edit/$demandPartnerId/$integrationId': typeof DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute
  '/demand/partners/$demandPartnerId/details/overview': typeof DemandPartnersDemandPartnerIdDetailsOverviewRoute
  '/supply/lists/rewrite/edit/$listId': typeof SupplyListsRewriteEditListIdRoute
  '/supply/lists/schain/edit/$listId': typeof SupplyListsSchainEditListIdRoute
  '/supply/publishers/$publisherId/details/a2v': typeof SupplyPublishersPublisherIdDetailsA2vRoute
  '/supply/publishers/$publisherId/details/app-requests': typeof SupplyPublishersPublisherIdDetailsAppRequestsRoute
  '/supply/publishers/$publisherId/details/apps': typeof SupplyPublishersPublisherIdDetailsAppsRoute
  '/supply/publishers/$publisherId/details/domains': typeof SupplyPublishersPublisherIdDetailsDomainsRoute
  '/supply/publishers/$publisherId/details/overview': typeof SupplyPublishersPublisherIdDetailsOverviewRoute
  '/supply/publishers/$publisherId/details/placements': typeof SupplyPublishersPublisherIdDetailsPlacementsRoute
  '/demand/partners/$demandPartnerId/details': typeof DemandPartnersDemandPartnerIdDetailsIndexRoute
  '/supply/publishers/$publisherId/details': typeof SupplyPublishersPublisherIdDetailsIndexRoute
  '/a/$agencyId/campaigns/brands/$brandId/details': typeof AAgencyIdCampaignsBrandsBrandIdDetailsRoute
  '/campaigns/campaigns/overview/$campaignId/line-items/create': typeof CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute
  '/campaigns/campaigns/overview/$campaignId/line-items/edit/$lineItemId': typeof CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/a2v': typeof A2vRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/campaigns': typeof CampaignsRouteWithChildren
  '/debug': typeof DebugRoute
  '/demand': typeof DemandRouteWithChildren
  '/design-system': typeof DesignSystemRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/networks': typeof NetworksRouteWithChildren
  '/reporting': typeof ReportingRouteWithChildren
  '/reset-password': typeof ResetPasswordRoute
  '/supply': typeof SupplyRouteWithChildren
  '/targeting': typeof TargetingRouteWithChildren
  '/a/$agencyId': typeof AAgencyIdRoute
  '/a2v/assets': typeof A2vAssetsRoute
  '/a2v/network-template': typeof A2vNetworkTemplateRoute
  '/admin/changelog': typeof AdminChangelogRoute
  '/admin/users': typeof AdminUsersRoute
  '/campaigns/agencies': typeof CampaignsAgenciesRoute
  '/campaigns/brands': typeof CampaignsBrandsRoute
  '/campaigns/campaigns': typeof CampaignsCampaignsRoute
  '/campaigns/channel-groups': typeof CampaignsChannelGroupsRoute
  '/campaigns/creatives': typeof CampaignsCreativesRoute
  '/demand/deals': typeof DemandDealsRouteWithChildren
  '/demand/integrations': typeof DemandIntegrationsRouteWithChildren
  '/demand/owners': typeof DemandOwnersRouteWithChildren
  '/demand/partners': typeof DemandPartnersRouteWithChildren
  '/networks/create': typeof NetworksCreateRoute
  '/p/$publisherId': typeof PPublisherIdRoute
  '/reporting/network-performance': typeof ReportingNetworkPerformanceRoute
  '/reporting/performance-analyzer': typeof ReportingPerformanceAnalyzerRoute
  '/reporting/report-explorer': typeof ReportingReportExplorerRoute
  '/reporting/saved-reports': typeof ReportingSavedReportsRoute
  '/supply/ads-txt': typeof SupplyAdsTxtRouteWithChildren
  '/supply/apps': typeof SupplyAppsRouteWithChildren
  '/supply/blocked-list': typeof SupplyBlockedListRouteWithChildren
  '/supply/domains': typeof SupplyDomainsRoute
  '/supply/endpoint-generator': typeof SupplyEndpointGeneratorRoute
  '/supply/lists': typeof SupplyListsRouteWithChildren
  '/supply/placements': typeof SupplyPlacementsRoute
  '/supply/publishers': typeof SupplyPublishersRoute
  '/supply/tailored-supply': typeof SupplyTailoredSupplyRouteWithChildren
  '/targeting/new': typeof TargetingNewRoute
  '/a2v/': typeof A2vIndexRoute
  '/admin/': typeof AdminIndexRoute
  '/demand/': typeof DemandIndexRoute
  '/networks/': typeof NetworksIndexRoute
  '/reporting/': typeof ReportingIndexRoute
  '/supply/': typeof SupplyIndexRoute
  '/targeting/': typeof TargetingIndexRoute
  '/campaigns/creatives_/display': typeof CampaignsCreativesDisplayRoute
  '/campaigns/creatives_/video': typeof CampaignsCreativesVideoRoute
  '/campaigns/supply/apps': typeof CampaignsSupplyAppsRoute
  '/campaigns/supply/domains': typeof CampaignsSupplyDomainsRoute
  '/campaigns/supply/tailored-supply': typeof CampaignsSupplyTailoredSupplyRouteWithChildren
  '/demand/deals/create': typeof DemandDealsCreateRoute
  '/demand/integrations/create': typeof DemandIntegrationsCreateRoute
  '/demand/owners/create': typeof DemandOwnersCreateRoute
  '/demand/partners/create': typeof DemandPartnersCreateRoute
  '/networks/$networkId/details': typeof NetworksNetworkIdDetailsRouteWithChildren
  '/networks/edit/$networkId': typeof NetworksEditNetworkIdRoute
  '/reporting/saved-reports_/shared': typeof ReportingSavedReportsSharedRoute
  '/supply/ads-txt/apps': typeof SupplyAdsTxtAppsRoute
  '/supply/ads-txt/domains': typeof SupplyAdsTxtDomainsRoute
  '/supply/ads-txt/records': typeof SupplyAdsTxtRecordsRoute
  '/supply/apps/requests': typeof SupplyAppsRequestsRoute
  '/supply/blocked-list/creatives': typeof SupplyBlockedListCreativesRoute
  '/supply/lists/all': typeof SupplyListsAllRoute
  '/supply/lists/rewrite': typeof SupplyListsRewriteRoute
  '/supply/lists/schain': typeof SupplyListsSchainRoute
  '/supply/publishers_/create': typeof SupplyPublishersCreateRoute
  '/supply/tailored-supply/create': typeof SupplyTailoredSupplyCreateRoute
  '/targeting/$targetingId/edit': typeof TargetingTargetingIdEditRoute
  '/demand/deals/': typeof DemandDealsIndexRoute
  '/demand/integrations/': typeof DemandIntegrationsIndexRoute
  '/demand/owners/': typeof DemandOwnersIndexRoute
  '/demand/partners/': typeof DemandPartnersIndexRoute
  '/supply/ads-txt/': typeof SupplyAdsTxtIndexRoute
  '/supply/apps/': typeof SupplyAppsIndexRoute
  '/supply/blocked-list/': typeof SupplyBlockedListIndexRoute
  '/supply/lists/': typeof SupplyListsIndexRoute
  '/supply/tailored-supply/': typeof SupplyTailoredSupplyIndexRoute
  '/a/$agencyId_/campaigns/$section': typeof AAgencyIdCampaignsSectionRoute
  '/a/$agencyId_/campaigns/overview': typeof AAgencyIdCampaignsOverviewRoute
  '/a/$agencyId_/reporting/report-explorer': typeof AAgencyIdReportingReportExplorerRoute
  '/a/$agencyId_/reporting/saved-reports': typeof AAgencyIdReportingSavedReportsRoute
  '/campaigns/agencies_/$agencyId/details': typeof CampaignsAgenciesAgencyIdDetailsRoute
  '/campaigns/brands_/$brandId/details': typeof CampaignsBrandsBrandIdDetailsRoute
  '/campaigns/campaigns_/overview/$campaignId': typeof CampaignsCampaignsOverviewCampaignIdRoute
  '/campaigns/creatives_/display_/create': typeof CampaignsCreativesDisplayCreateRoute
  '/campaigns/creatives_/video_/create': typeof CampaignsCreativesVideoCreateRoute
  '/campaigns/supply/tailored-supply/create': typeof CampaignsSupplyTailoredSupplyCreateRoute
  '/demand/deals/edit/$dealId': typeof DemandDealsEditDealIdRoute
  '/demand/owners/edit/$ownerId': typeof DemandOwnersEditOwnerIdRoute
  '/demand/partners/$demandPartnerId/details': typeof DemandPartnersDemandPartnerIdDetailsRouteWithChildren
  '/demand/partners/edit/$demandPartnerId': typeof DemandPartnersEditDemandPartnerIdRoute
  '/networks/$networkId/details/overview': typeof NetworksNetworkIdDetailsOverviewRoute
  '/p/$publisherId_/reporting/report-explorer': typeof PPublisherIdReportingReportExplorerRoute
  '/supply/apps_/edit/$appId': typeof SupplyAppsEditAppIdRoute
  '/supply/lists_/rewrite_/create': typeof SupplyListsRewriteCreateRoute
  '/supply/lists_/schain_/create': typeof SupplyListsSchainCreateRoute
  '/supply/placements_/create/$placementType': typeof SupplyPlacementsCreatePlacementTypeRoute
  '/supply/placements_/edit/$placementId': typeof SupplyPlacementsEditPlacementIdRoute
  '/supply/publishers_/$publisherId/details': typeof SupplyPublishersPublisherIdDetailsRouteWithChildren
  '/supply/publishers_/edit/$publisherId': typeof SupplyPublishersEditPublisherIdRoute
  '/campaigns/supply/tailored-supply/': typeof CampaignsSupplyTailoredSupplyIndexRoute
  '/networks/$networkId/details/': typeof NetworksNetworkIdDetailsIndexRoute
  '/campaigns/creatives_/display_/edit/$creativeId': typeof CampaignsCreativesDisplayEditCreativeIdRoute
  '/campaigns/creatives_/video_/edit/$creativeId': typeof CampaignsCreativesVideoEditCreativeIdRoute
  '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId': typeof CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute
  '/demand/integrations/edit/$demandPartnerId/$integrationId': typeof DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute
  '/demand/partners/$demandPartnerId/details/overview': typeof DemandPartnersDemandPartnerIdDetailsOverviewRoute
  '/supply/lists_/rewrite_/edit/$listId': typeof SupplyListsRewriteEditListIdRoute
  '/supply/lists_/schain_/edit/$listId': typeof SupplyListsSchainEditListIdRoute
  '/supply/publishers_/$publisherId/details/a2v': typeof SupplyPublishersPublisherIdDetailsA2vRoute
  '/supply/publishers_/$publisherId/details/app-requests': typeof SupplyPublishersPublisherIdDetailsAppRequestsRoute
  '/supply/publishers_/$publisherId/details/apps': typeof SupplyPublishersPublisherIdDetailsAppsRoute
  '/supply/publishers_/$publisherId/details/domains': typeof SupplyPublishersPublisherIdDetailsDomainsRoute
  '/supply/publishers_/$publisherId/details/overview': typeof SupplyPublishersPublisherIdDetailsOverviewRoute
  '/supply/publishers_/$publisherId/details/placements': typeof SupplyPublishersPublisherIdDetailsPlacementsRoute
  '/demand/partners/$demandPartnerId/details/': typeof DemandPartnersDemandPartnerIdDetailsIndexRoute
  '/supply/publishers_/$publisherId/details/': typeof SupplyPublishersPublisherIdDetailsIndexRoute
  '/a/$agencyId_/campaigns/brands/$brandId/details': typeof AAgencyIdCampaignsBrandsBrandIdDetailsRoute
  '/campaigns/campaigns_/overview/$campaignId_/line-items/create': typeof CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteWithChildren
  '/campaigns/campaigns_/overview/$campaignId_/line-items/edit/$lineItemId': typeof CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/': typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a2v'
    | '/admin'
    | '/campaigns'
    | '/debug'
    | '/demand'
    | '/design-system'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/networks'
    | '/reporting'
    | '/reset-password'
    | '/supply'
    | '/targeting'
    | '/a/$agencyId'
    | '/a2v/assets'
    | '/a2v/network-template'
    | '/admin/changelog'
    | '/admin/users'
    | '/campaigns/agencies'
    | '/campaigns/brands'
    | '/campaigns/campaigns'
    | '/campaigns/channel-groups'
    | '/campaigns/creatives'
    | '/demand/deals'
    | '/demand/integrations'
    | '/demand/owners'
    | '/demand/partners'
    | '/networks/create'
    | '/p/$publisherId'
    | '/reporting/network-performance'
    | '/reporting/performance-analyzer'
    | '/reporting/report-explorer'
    | '/reporting/saved-reports'
    | '/supply/ads-txt'
    | '/supply/apps'
    | '/supply/blocked-list'
    | '/supply/domains'
    | '/supply/endpoint-generator'
    | '/supply/lists'
    | '/supply/placements'
    | '/supply/publishers'
    | '/supply/tailored-supply'
    | '/targeting/new'
    | '/a2v/'
    | '/admin/'
    | '/demand/'
    | '/networks/'
    | '/reporting/'
    | '/supply/'
    | '/targeting/'
    | '/campaigns/creatives/display'
    | '/campaigns/creatives/video'
    | '/campaigns/supply/apps'
    | '/campaigns/supply/domains'
    | '/campaigns/supply/tailored-supply'
    | '/demand/deals/create'
    | '/demand/integrations/create'
    | '/demand/owners/create'
    | '/demand/partners/create'
    | '/networks/$networkId/details'
    | '/networks/edit/$networkId'
    | '/reporting/saved-reports/shared'
    | '/supply/ads-txt/apps'
    | '/supply/ads-txt/domains'
    | '/supply/ads-txt/records'
    | '/supply/apps/requests'
    | '/supply/blocked-list/creatives'
    | '/supply/lists/all'
    | '/supply/lists/rewrite'
    | '/supply/lists/schain'
    | '/supply/publishers/create'
    | '/supply/tailored-supply/create'
    | '/targeting/$targetingId/edit'
    | '/demand/deals/'
    | '/demand/integrations/'
    | '/demand/owners/'
    | '/demand/partners/'
    | '/supply/ads-txt/'
    | '/supply/apps/'
    | '/supply/blocked-list/'
    | '/supply/lists/'
    | '/supply/tailored-supply/'
    | '/a/$agencyId/campaigns/$section'
    | '/a/$agencyId/campaigns/overview'
    | '/a/$agencyId/reporting/report-explorer'
    | '/a/$agencyId/reporting/saved-reports'
    | '/campaigns/agencies/$agencyId/details'
    | '/campaigns/brands/$brandId/details'
    | '/campaigns/campaigns/overview/$campaignId'
    | '/campaigns/creatives/display/create'
    | '/campaigns/creatives/video/create'
    | '/campaigns/supply/tailored-supply/create'
    | '/demand/deals/edit/$dealId'
    | '/demand/owners/edit/$ownerId'
    | '/demand/partners/$demandPartnerId/details'
    | '/demand/partners/edit/$demandPartnerId'
    | '/networks/$networkId/details/overview'
    | '/p/$publisherId/reporting/report-explorer'
    | '/supply/apps/edit/$appId'
    | '/supply/lists/rewrite/create'
    | '/supply/lists/schain/create'
    | '/supply/placements/create/$placementType'
    | '/supply/placements/edit/$placementId'
    | '/supply/publishers/$publisherId/details'
    | '/supply/publishers/edit/$publisherId'
    | '/campaigns/supply/tailored-supply/'
    | '/networks/$networkId/details/'
    | '/campaigns/creatives/display/edit/$creativeId'
    | '/campaigns/creatives/video/edit/$creativeId'
    | '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId'
    | '/demand/integrations/edit/$demandPartnerId/$integrationId'
    | '/demand/partners/$demandPartnerId/details/overview'
    | '/supply/lists/rewrite/edit/$listId'
    | '/supply/lists/schain/edit/$listId'
    | '/supply/publishers/$publisherId/details/a2v'
    | '/supply/publishers/$publisherId/details/app-requests'
    | '/supply/publishers/$publisherId/details/apps'
    | '/supply/publishers/$publisherId/details/domains'
    | '/supply/publishers/$publisherId/details/overview'
    | '/supply/publishers/$publisherId/details/placements'
    | '/demand/partners/$demandPartnerId/details/'
    | '/supply/publishers/$publisherId/details/'
    | '/a/$agencyId/campaigns/brands/$brandId/details'
    | '/campaigns/campaigns/overview/$campaignId/line-items/create'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details'
    | '/campaigns/campaigns/overview/$campaignId/line-items/edit/$lineItemId'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/campaigns'
    | '/debug'
    | '/design-system'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/reset-password'
    | '/a/$agencyId'
    | '/a2v/assets'
    | '/a2v/network-template'
    | '/admin/changelog'
    | '/admin/users'
    | '/campaigns/agencies'
    | '/campaigns/brands'
    | '/campaigns/campaigns'
    | '/campaigns/channel-groups'
    | '/campaigns/creatives'
    | '/networks/create'
    | '/p/$publisherId'
    | '/reporting/network-performance'
    | '/reporting/performance-analyzer'
    | '/reporting/report-explorer'
    | '/reporting/saved-reports'
    | '/supply/domains'
    | '/supply/endpoint-generator'
    | '/supply/placements'
    | '/supply/publishers'
    | '/targeting/new'
    | '/a2v'
    | '/admin'
    | '/demand'
    | '/networks'
    | '/reporting'
    | '/supply'
    | '/targeting'
    | '/campaigns/creatives/display'
    | '/campaigns/creatives/video'
    | '/campaigns/supply/apps'
    | '/campaigns/supply/domains'
    | '/demand/deals/create'
    | '/demand/integrations/create'
    | '/demand/owners/create'
    | '/demand/partners/create'
    | '/networks/edit/$networkId'
    | '/reporting/saved-reports/shared'
    | '/supply/ads-txt/apps'
    | '/supply/ads-txt/domains'
    | '/supply/ads-txt/records'
    | '/supply/apps/requests'
    | '/supply/blocked-list/creatives'
    | '/supply/lists/all'
    | '/supply/lists/rewrite'
    | '/supply/lists/schain'
    | '/supply/publishers/create'
    | '/supply/tailored-supply/create'
    | '/targeting/$targetingId/edit'
    | '/demand/deals'
    | '/demand/integrations'
    | '/demand/owners'
    | '/demand/partners'
    | '/supply/ads-txt'
    | '/supply/apps'
    | '/supply/blocked-list'
    | '/supply/lists'
    | '/supply/tailored-supply'
    | '/a/$agencyId/campaigns/$section'
    | '/a/$agencyId/campaigns/overview'
    | '/a/$agencyId/reporting/report-explorer'
    | '/a/$agencyId/reporting/saved-reports'
    | '/campaigns/agencies/$agencyId/details'
    | '/campaigns/brands/$brandId/details'
    | '/campaigns/campaigns/overview/$campaignId'
    | '/campaigns/creatives/display/create'
    | '/campaigns/creatives/video/create'
    | '/campaigns/supply/tailored-supply/create'
    | '/demand/deals/edit/$dealId'
    | '/demand/owners/edit/$ownerId'
    | '/demand/partners/edit/$demandPartnerId'
    | '/networks/$networkId/details/overview'
    | '/p/$publisherId/reporting/report-explorer'
    | '/supply/apps/edit/$appId'
    | '/supply/lists/rewrite/create'
    | '/supply/lists/schain/create'
    | '/supply/placements/create/$placementType'
    | '/supply/placements/edit/$placementId'
    | '/supply/publishers/edit/$publisherId'
    | '/campaigns/supply/tailored-supply'
    | '/networks/$networkId/details'
    | '/campaigns/creatives/display/edit/$creativeId'
    | '/campaigns/creatives/video/edit/$creativeId'
    | '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId'
    | '/demand/integrations/edit/$demandPartnerId/$integrationId'
    | '/demand/partners/$demandPartnerId/details/overview'
    | '/supply/lists/rewrite/edit/$listId'
    | '/supply/lists/schain/edit/$listId'
    | '/supply/publishers/$publisherId/details/a2v'
    | '/supply/publishers/$publisherId/details/app-requests'
    | '/supply/publishers/$publisherId/details/apps'
    | '/supply/publishers/$publisherId/details/domains'
    | '/supply/publishers/$publisherId/details/overview'
    | '/supply/publishers/$publisherId/details/placements'
    | '/demand/partners/$demandPartnerId/details'
    | '/supply/publishers/$publisherId/details'
    | '/a/$agencyId/campaigns/brands/$brandId/details'
    | '/campaigns/campaigns/overview/$campaignId/line-items/create'
    | '/campaigns/campaigns/overview/$campaignId/line-items/edit/$lineItemId'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details'
  id:
    | '__root__'
    | '/'
    | '/a2v'
    | '/admin'
    | '/campaigns'
    | '/debug'
    | '/demand'
    | '/design-system'
    | '/forgot-password'
    | '/login'
    | '/logout'
    | '/networks'
    | '/reporting'
    | '/reset-password'
    | '/supply'
    | '/targeting'
    | '/a/$agencyId'
    | '/a2v/assets'
    | '/a2v/network-template'
    | '/admin/changelog'
    | '/admin/users'
    | '/campaigns/agencies'
    | '/campaigns/brands'
    | '/campaigns/campaigns'
    | '/campaigns/channel-groups'
    | '/campaigns/creatives'
    | '/demand/deals'
    | '/demand/integrations'
    | '/demand/owners'
    | '/demand/partners'
    | '/networks/create'
    | '/p/$publisherId'
    | '/reporting/network-performance'
    | '/reporting/performance-analyzer'
    | '/reporting/report-explorer'
    | '/reporting/saved-reports'
    | '/supply/ads-txt'
    | '/supply/apps'
    | '/supply/blocked-list'
    | '/supply/domains'
    | '/supply/endpoint-generator'
    | '/supply/lists'
    | '/supply/placements'
    | '/supply/publishers'
    | '/supply/tailored-supply'
    | '/targeting/new'
    | '/a2v/'
    | '/admin/'
    | '/demand/'
    | '/networks/'
    | '/reporting/'
    | '/supply/'
    | '/targeting/'
    | '/campaigns/creatives_/display'
    | '/campaigns/creatives_/video'
    | '/campaigns/supply/apps'
    | '/campaigns/supply/domains'
    | '/campaigns/supply/tailored-supply'
    | '/demand/deals/create'
    | '/demand/integrations/create'
    | '/demand/owners/create'
    | '/demand/partners/create'
    | '/networks/$networkId/details'
    | '/networks/edit/$networkId'
    | '/reporting/saved-reports_/shared'
    | '/supply/ads-txt/apps'
    | '/supply/ads-txt/domains'
    | '/supply/ads-txt/records'
    | '/supply/apps/requests'
    | '/supply/blocked-list/creatives'
    | '/supply/lists/all'
    | '/supply/lists/rewrite'
    | '/supply/lists/schain'
    | '/supply/publishers_/create'
    | '/supply/tailored-supply/create'
    | '/targeting/$targetingId/edit'
    | '/demand/deals/'
    | '/demand/integrations/'
    | '/demand/owners/'
    | '/demand/partners/'
    | '/supply/ads-txt/'
    | '/supply/apps/'
    | '/supply/blocked-list/'
    | '/supply/lists/'
    | '/supply/tailored-supply/'
    | '/a/$agencyId_/campaigns/$section'
    | '/a/$agencyId_/campaigns/overview'
    | '/a/$agencyId_/reporting/report-explorer'
    | '/a/$agencyId_/reporting/saved-reports'
    | '/campaigns/agencies_/$agencyId/details'
    | '/campaigns/brands_/$brandId/details'
    | '/campaigns/campaigns_/overview/$campaignId'
    | '/campaigns/creatives_/display_/create'
    | '/campaigns/creatives_/video_/create'
    | '/campaigns/supply/tailored-supply/create'
    | '/demand/deals/edit/$dealId'
    | '/demand/owners/edit/$ownerId'
    | '/demand/partners/$demandPartnerId/details'
    | '/demand/partners/edit/$demandPartnerId'
    | '/networks/$networkId/details/overview'
    | '/p/$publisherId_/reporting/report-explorer'
    | '/supply/apps_/edit/$appId'
    | '/supply/lists_/rewrite_/create'
    | '/supply/lists_/schain_/create'
    | '/supply/placements_/create/$placementType'
    | '/supply/placements_/edit/$placementId'
    | '/supply/publishers_/$publisherId/details'
    | '/supply/publishers_/edit/$publisherId'
    | '/campaigns/supply/tailored-supply/'
    | '/networks/$networkId/details/'
    | '/campaigns/creatives_/display_/edit/$creativeId'
    | '/campaigns/creatives_/video_/edit/$creativeId'
    | '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId'
    | '/demand/integrations/edit/$demandPartnerId/$integrationId'
    | '/demand/partners/$demandPartnerId/details/overview'
    | '/supply/lists_/rewrite_/edit/$listId'
    | '/supply/lists_/schain_/edit/$listId'
    | '/supply/publishers_/$publisherId/details/a2v'
    | '/supply/publishers_/$publisherId/details/app-requests'
    | '/supply/publishers_/$publisherId/details/apps'
    | '/supply/publishers_/$publisherId/details/domains'
    | '/supply/publishers_/$publisherId/details/overview'
    | '/supply/publishers_/$publisherId/details/placements'
    | '/demand/partners/$demandPartnerId/details/'
    | '/supply/publishers_/$publisherId/details/'
    | '/a/$agencyId_/campaigns/brands/$brandId/details'
    | '/campaigns/campaigns_/overview/$campaignId_/line-items/create'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details'
    | '/campaigns/campaigns_/overview/$campaignId_/line-items/edit/$lineItemId'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements'
    | '/demand/integrations/$integrationId/demand/$demandPartnerId/details/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  A2vRoute: typeof A2vRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  CampaignsRoute: typeof CampaignsRouteWithChildren
  DebugRoute: typeof DebugRoute
  DemandRoute: typeof DemandRouteWithChildren
  DesignSystemRoute: typeof DesignSystemRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  NetworksRoute: typeof NetworksRouteWithChildren
  ReportingRoute: typeof ReportingRouteWithChildren
  ResetPasswordRoute: typeof ResetPasswordRoute
  SupplyRoute: typeof SupplyRouteWithChildren
  TargetingRoute: typeof TargetingRouteWithChildren
  AAgencyIdRoute: typeof AAgencyIdRoute
  PPublisherIdRoute: typeof PPublisherIdRoute
  AAgencyIdCampaignsSectionRoute: typeof AAgencyIdCampaignsSectionRoute
  AAgencyIdCampaignsOverviewRoute: typeof AAgencyIdCampaignsOverviewRoute
  AAgencyIdReportingReportExplorerRoute: typeof AAgencyIdReportingReportExplorerRoute
  AAgencyIdReportingSavedReportsRoute: typeof AAgencyIdReportingSavedReportsRoute
  PPublisherIdReportingReportExplorerRoute: typeof PPublisherIdReportingReportExplorerRoute
  AAgencyIdCampaignsBrandsBrandIdDetailsRoute: typeof AAgencyIdCampaignsBrandsBrandIdDetailsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/targeting': {
      id: '/targeting'
      path: '/targeting'
      fullPath: '/targeting'
      preLoaderRoute: typeof TargetingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supply': {
      id: '/supply'
      path: '/supply'
      fullPath: '/supply'
      preLoaderRoute: typeof SupplyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reporting': {
      id: '/reporting'
      path: '/reporting'
      fullPath: '/reporting'
      preLoaderRoute: typeof ReportingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/networks': {
      id: '/networks'
      path: '/networks'
      fullPath: '/networks'
      preLoaderRoute: typeof NetworksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/design-system': {
      id: '/design-system'
      path: '/design-system'
      fullPath: '/design-system'
      preLoaderRoute: typeof DesignSystemRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand': {
      id: '/demand'
      path: '/demand'
      fullPath: '/demand'
      preLoaderRoute: typeof DemandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/debug': {
      id: '/debug'
      path: '/debug'
      fullPath: '/debug'
      preLoaderRoute: typeof DebugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns': {
      id: '/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns'
      preLoaderRoute: typeof CampaignsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a2v': {
      id: '/a2v'
      path: '/a2v'
      fullPath: '/a2v'
      preLoaderRoute: typeof A2vRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/targeting/': {
      id: '/targeting/'
      path: '/'
      fullPath: '/targeting/'
      preLoaderRoute: typeof TargetingIndexRouteImport
      parentRoute: typeof TargetingRoute
    }
    '/supply/': {
      id: '/supply/'
      path: '/'
      fullPath: '/supply/'
      preLoaderRoute: typeof SupplyIndexRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/reporting/': {
      id: '/reporting/'
      path: '/'
      fullPath: '/reporting/'
      preLoaderRoute: typeof ReportingIndexRouteImport
      parentRoute: typeof ReportingRoute
    }
    '/networks/': {
      id: '/networks/'
      path: '/'
      fullPath: '/networks/'
      preLoaderRoute: typeof NetworksIndexRouteImport
      parentRoute: typeof NetworksRoute
    }
    '/demand/': {
      id: '/demand/'
      path: '/'
      fullPath: '/demand/'
      preLoaderRoute: typeof DemandIndexRouteImport
      parentRoute: typeof DemandRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/a2v/': {
      id: '/a2v/'
      path: '/'
      fullPath: '/a2v/'
      preLoaderRoute: typeof A2vIndexRouteImport
      parentRoute: typeof A2vRoute
    }
    '/targeting/new': {
      id: '/targeting/new'
      path: '/new'
      fullPath: '/targeting/new'
      preLoaderRoute: typeof TargetingNewRouteImport
      parentRoute: typeof TargetingRoute
    }
    '/supply/tailored-supply': {
      id: '/supply/tailored-supply'
      path: '/tailored-supply'
      fullPath: '/supply/tailored-supply'
      preLoaderRoute: typeof SupplyTailoredSupplyRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/publishers': {
      id: '/supply/publishers'
      path: '/publishers'
      fullPath: '/supply/publishers'
      preLoaderRoute: typeof SupplyPublishersRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/placements': {
      id: '/supply/placements'
      path: '/placements'
      fullPath: '/supply/placements'
      preLoaderRoute: typeof SupplyPlacementsRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/lists': {
      id: '/supply/lists'
      path: '/lists'
      fullPath: '/supply/lists'
      preLoaderRoute: typeof SupplyListsRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/endpoint-generator': {
      id: '/supply/endpoint-generator'
      path: '/endpoint-generator'
      fullPath: '/supply/endpoint-generator'
      preLoaderRoute: typeof SupplyEndpointGeneratorRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/domains': {
      id: '/supply/domains'
      path: '/domains'
      fullPath: '/supply/domains'
      preLoaderRoute: typeof SupplyDomainsRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/blocked-list': {
      id: '/supply/blocked-list'
      path: '/blocked-list'
      fullPath: '/supply/blocked-list'
      preLoaderRoute: typeof SupplyBlockedListRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/apps': {
      id: '/supply/apps'
      path: '/apps'
      fullPath: '/supply/apps'
      preLoaderRoute: typeof SupplyAppsRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/ads-txt': {
      id: '/supply/ads-txt'
      path: '/ads-txt'
      fullPath: '/supply/ads-txt'
      preLoaderRoute: typeof SupplyAdsTxtRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/reporting/saved-reports': {
      id: '/reporting/saved-reports'
      path: '/saved-reports'
      fullPath: '/reporting/saved-reports'
      preLoaderRoute: typeof ReportingSavedReportsRouteImport
      parentRoute: typeof ReportingRoute
    }
    '/reporting/report-explorer': {
      id: '/reporting/report-explorer'
      path: '/report-explorer'
      fullPath: '/reporting/report-explorer'
      preLoaderRoute: typeof ReportingReportExplorerRouteImport
      parentRoute: typeof ReportingRoute
    }
    '/reporting/performance-analyzer': {
      id: '/reporting/performance-analyzer'
      path: '/performance-analyzer'
      fullPath: '/reporting/performance-analyzer'
      preLoaderRoute: typeof ReportingPerformanceAnalyzerRouteImport
      parentRoute: typeof ReportingRoute
    }
    '/reporting/network-performance': {
      id: '/reporting/network-performance'
      path: '/network-performance'
      fullPath: '/reporting/network-performance'
      preLoaderRoute: typeof ReportingNetworkPerformanceRouteImport
      parentRoute: typeof ReportingRoute
    }
    '/p/$publisherId': {
      id: '/p/$publisherId'
      path: '/p/$publisherId'
      fullPath: '/p/$publisherId'
      preLoaderRoute: typeof PPublisherIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/networks/create': {
      id: '/networks/create'
      path: '/create'
      fullPath: '/networks/create'
      preLoaderRoute: typeof NetworksCreateRouteImport
      parentRoute: typeof NetworksRoute
    }
    '/demand/partners': {
      id: '/demand/partners'
      path: '/partners'
      fullPath: '/demand/partners'
      preLoaderRoute: typeof DemandPartnersRouteImport
      parentRoute: typeof DemandRoute
    }
    '/demand/owners': {
      id: '/demand/owners'
      path: '/owners'
      fullPath: '/demand/owners'
      preLoaderRoute: typeof DemandOwnersRouteImport
      parentRoute: typeof DemandRoute
    }
    '/demand/integrations': {
      id: '/demand/integrations'
      path: '/integrations'
      fullPath: '/demand/integrations'
      preLoaderRoute: typeof DemandIntegrationsRouteImport
      parentRoute: typeof DemandRoute
    }
    '/demand/deals': {
      id: '/demand/deals'
      path: '/deals'
      fullPath: '/demand/deals'
      preLoaderRoute: typeof DemandDealsRouteImport
      parentRoute: typeof DemandRoute
    }
    '/campaigns/creatives': {
      id: '/campaigns/creatives'
      path: '/creatives'
      fullPath: '/campaigns/creatives'
      preLoaderRoute: typeof CampaignsCreativesRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/channel-groups': {
      id: '/campaigns/channel-groups'
      path: '/channel-groups'
      fullPath: '/campaigns/channel-groups'
      preLoaderRoute: typeof CampaignsChannelGroupsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/campaigns': {
      id: '/campaigns/campaigns'
      path: '/campaigns'
      fullPath: '/campaigns/campaigns'
      preLoaderRoute: typeof CampaignsCampaignsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/brands': {
      id: '/campaigns/brands'
      path: '/brands'
      fullPath: '/campaigns/brands'
      preLoaderRoute: typeof CampaignsBrandsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/agencies': {
      id: '/campaigns/agencies'
      path: '/agencies'
      fullPath: '/campaigns/agencies'
      preLoaderRoute: typeof CampaignsAgenciesRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/changelog': {
      id: '/admin/changelog'
      path: '/changelog'
      fullPath: '/admin/changelog'
      preLoaderRoute: typeof AdminChangelogRouteImport
      parentRoute: typeof AdminRoute
    }
    '/a2v/network-template': {
      id: '/a2v/network-template'
      path: '/network-template'
      fullPath: '/a2v/network-template'
      preLoaderRoute: typeof A2vNetworkTemplateRouteImport
      parentRoute: typeof A2vRoute
    }
    '/a2v/assets': {
      id: '/a2v/assets'
      path: '/assets'
      fullPath: '/a2v/assets'
      preLoaderRoute: typeof A2vAssetsRouteImport
      parentRoute: typeof A2vRoute
    }
    '/a/$agencyId': {
      id: '/a/$agencyId'
      path: '/a/$agencyId'
      fullPath: '/a/$agencyId'
      preLoaderRoute: typeof AAgencyIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supply/tailored-supply/': {
      id: '/supply/tailored-supply/'
      path: '/'
      fullPath: '/supply/tailored-supply/'
      preLoaderRoute: typeof SupplyTailoredSupplyIndexRouteImport
      parentRoute: typeof SupplyTailoredSupplyRoute
    }
    '/supply/lists/': {
      id: '/supply/lists/'
      path: '/'
      fullPath: '/supply/lists/'
      preLoaderRoute: typeof SupplyListsIndexRouteImport
      parentRoute: typeof SupplyListsRoute
    }
    '/supply/blocked-list/': {
      id: '/supply/blocked-list/'
      path: '/'
      fullPath: '/supply/blocked-list/'
      preLoaderRoute: typeof SupplyBlockedListIndexRouteImport
      parentRoute: typeof SupplyBlockedListRoute
    }
    '/supply/apps/': {
      id: '/supply/apps/'
      path: '/'
      fullPath: '/supply/apps/'
      preLoaderRoute: typeof SupplyAppsIndexRouteImport
      parentRoute: typeof SupplyAppsRoute
    }
    '/supply/ads-txt/': {
      id: '/supply/ads-txt/'
      path: '/'
      fullPath: '/supply/ads-txt/'
      preLoaderRoute: typeof SupplyAdsTxtIndexRouteImport
      parentRoute: typeof SupplyAdsTxtRoute
    }
    '/demand/partners/': {
      id: '/demand/partners/'
      path: '/'
      fullPath: '/demand/partners/'
      preLoaderRoute: typeof DemandPartnersIndexRouteImport
      parentRoute: typeof DemandPartnersRoute
    }
    '/demand/owners/': {
      id: '/demand/owners/'
      path: '/'
      fullPath: '/demand/owners/'
      preLoaderRoute: typeof DemandOwnersIndexRouteImport
      parentRoute: typeof DemandOwnersRoute
    }
    '/demand/integrations/': {
      id: '/demand/integrations/'
      path: '/'
      fullPath: '/demand/integrations/'
      preLoaderRoute: typeof DemandIntegrationsIndexRouteImport
      parentRoute: typeof DemandIntegrationsRoute
    }
    '/demand/deals/': {
      id: '/demand/deals/'
      path: '/'
      fullPath: '/demand/deals/'
      preLoaderRoute: typeof DemandDealsIndexRouteImport
      parentRoute: typeof DemandDealsRoute
    }
    '/targeting/$targetingId/edit': {
      id: '/targeting/$targetingId/edit'
      path: '/$targetingId/edit'
      fullPath: '/targeting/$targetingId/edit'
      preLoaderRoute: typeof TargetingTargetingIdEditRouteImport
      parentRoute: typeof TargetingRoute
    }
    '/supply/tailored-supply/create': {
      id: '/supply/tailored-supply/create'
      path: '/create'
      fullPath: '/supply/tailored-supply/create'
      preLoaderRoute: typeof SupplyTailoredSupplyCreateRouteImport
      parentRoute: typeof SupplyTailoredSupplyRoute
    }
    '/supply/publishers_/create': {
      id: '/supply/publishers_/create'
      path: '/publishers/create'
      fullPath: '/supply/publishers/create'
      preLoaderRoute: typeof SupplyPublishersCreateRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/lists/schain': {
      id: '/supply/lists/schain'
      path: '/schain'
      fullPath: '/supply/lists/schain'
      preLoaderRoute: typeof SupplyListsSchainRouteImport
      parentRoute: typeof SupplyListsRoute
    }
    '/supply/lists/rewrite': {
      id: '/supply/lists/rewrite'
      path: '/rewrite'
      fullPath: '/supply/lists/rewrite'
      preLoaderRoute: typeof SupplyListsRewriteRouteImport
      parentRoute: typeof SupplyListsRoute
    }
    '/supply/lists/all': {
      id: '/supply/lists/all'
      path: '/all'
      fullPath: '/supply/lists/all'
      preLoaderRoute: typeof SupplyListsAllRouteImport
      parentRoute: typeof SupplyListsRoute
    }
    '/supply/blocked-list/creatives': {
      id: '/supply/blocked-list/creatives'
      path: '/creatives'
      fullPath: '/supply/blocked-list/creatives'
      preLoaderRoute: typeof SupplyBlockedListCreativesRouteImport
      parentRoute: typeof SupplyBlockedListRoute
    }
    '/supply/apps/requests': {
      id: '/supply/apps/requests'
      path: '/requests'
      fullPath: '/supply/apps/requests'
      preLoaderRoute: typeof SupplyAppsRequestsRouteImport
      parentRoute: typeof SupplyAppsRoute
    }
    '/supply/ads-txt/records': {
      id: '/supply/ads-txt/records'
      path: '/records'
      fullPath: '/supply/ads-txt/records'
      preLoaderRoute: typeof SupplyAdsTxtRecordsRouteImport
      parentRoute: typeof SupplyAdsTxtRoute
    }
    '/supply/ads-txt/domains': {
      id: '/supply/ads-txt/domains'
      path: '/domains'
      fullPath: '/supply/ads-txt/domains'
      preLoaderRoute: typeof SupplyAdsTxtDomainsRouteImport
      parentRoute: typeof SupplyAdsTxtRoute
    }
    '/supply/ads-txt/apps': {
      id: '/supply/ads-txt/apps'
      path: '/apps'
      fullPath: '/supply/ads-txt/apps'
      preLoaderRoute: typeof SupplyAdsTxtAppsRouteImport
      parentRoute: typeof SupplyAdsTxtRoute
    }
    '/reporting/saved-reports_/shared': {
      id: '/reporting/saved-reports_/shared'
      path: '/saved-reports/shared'
      fullPath: '/reporting/saved-reports/shared'
      preLoaderRoute: typeof ReportingSavedReportsSharedRouteImport
      parentRoute: typeof ReportingRoute
    }
    '/networks/edit/$networkId': {
      id: '/networks/edit/$networkId'
      path: '/edit/$networkId'
      fullPath: '/networks/edit/$networkId'
      preLoaderRoute: typeof NetworksEditNetworkIdRouteImport
      parentRoute: typeof NetworksRoute
    }
    '/networks/$networkId/details': {
      id: '/networks/$networkId/details'
      path: '/$networkId/details'
      fullPath: '/networks/$networkId/details'
      preLoaderRoute: typeof NetworksNetworkIdDetailsRouteImport
      parentRoute: typeof NetworksRoute
    }
    '/demand/partners/create': {
      id: '/demand/partners/create'
      path: '/create'
      fullPath: '/demand/partners/create'
      preLoaderRoute: typeof DemandPartnersCreateRouteImport
      parentRoute: typeof DemandPartnersRoute
    }
    '/demand/owners/create': {
      id: '/demand/owners/create'
      path: '/create'
      fullPath: '/demand/owners/create'
      preLoaderRoute: typeof DemandOwnersCreateRouteImport
      parentRoute: typeof DemandOwnersRoute
    }
    '/demand/integrations/create': {
      id: '/demand/integrations/create'
      path: '/create'
      fullPath: '/demand/integrations/create'
      preLoaderRoute: typeof DemandIntegrationsCreateRouteImport
      parentRoute: typeof DemandIntegrationsRoute
    }
    '/demand/deals/create': {
      id: '/demand/deals/create'
      path: '/create'
      fullPath: '/demand/deals/create'
      preLoaderRoute: typeof DemandDealsCreateRouteImport
      parentRoute: typeof DemandDealsRoute
    }
    '/campaigns/supply/tailored-supply': {
      id: '/campaigns/supply/tailored-supply'
      path: '/supply/tailored-supply'
      fullPath: '/campaigns/supply/tailored-supply'
      preLoaderRoute: typeof CampaignsSupplyTailoredSupplyRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/supply/domains': {
      id: '/campaigns/supply/domains'
      path: '/supply/domains'
      fullPath: '/campaigns/supply/domains'
      preLoaderRoute: typeof CampaignsSupplyDomainsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/supply/apps': {
      id: '/campaigns/supply/apps'
      path: '/supply/apps'
      fullPath: '/campaigns/supply/apps'
      preLoaderRoute: typeof CampaignsSupplyAppsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/creatives_/video': {
      id: '/campaigns/creatives_/video'
      path: '/creatives/video'
      fullPath: '/campaigns/creatives/video'
      preLoaderRoute: typeof CampaignsCreativesVideoRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/creatives_/display': {
      id: '/campaigns/creatives_/display'
      path: '/creatives/display'
      fullPath: '/campaigns/creatives/display'
      preLoaderRoute: typeof CampaignsCreativesDisplayRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/networks/$networkId/details/': {
      id: '/networks/$networkId/details/'
      path: '/'
      fullPath: '/networks/$networkId/details/'
      preLoaderRoute: typeof NetworksNetworkIdDetailsIndexRouteImport
      parentRoute: typeof NetworksNetworkIdDetailsRoute
    }
    '/campaigns/supply/tailored-supply/': {
      id: '/campaigns/supply/tailored-supply/'
      path: '/'
      fullPath: '/campaigns/supply/tailored-supply/'
      preLoaderRoute: typeof CampaignsSupplyTailoredSupplyIndexRouteImport
      parentRoute: typeof CampaignsSupplyTailoredSupplyRoute
    }
    '/supply/publishers_/edit/$publisherId': {
      id: '/supply/publishers_/edit/$publisherId'
      path: '/publishers/edit/$publisherId'
      fullPath: '/supply/publishers/edit/$publisherId'
      preLoaderRoute: typeof SupplyPublishersEditPublisherIdRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/publishers_/$publisherId/details': {
      id: '/supply/publishers_/$publisherId/details'
      path: '/publishers/$publisherId/details'
      fullPath: '/supply/publishers/$publisherId/details'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/placements_/edit/$placementId': {
      id: '/supply/placements_/edit/$placementId'
      path: '/placements/edit/$placementId'
      fullPath: '/supply/placements/edit/$placementId'
      preLoaderRoute: typeof SupplyPlacementsEditPlacementIdRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/placements_/create/$placementType': {
      id: '/supply/placements_/create/$placementType'
      path: '/placements/create/$placementType'
      fullPath: '/supply/placements/create/$placementType'
      preLoaderRoute: typeof SupplyPlacementsCreatePlacementTypeRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/lists_/schain_/create': {
      id: '/supply/lists_/schain_/create'
      path: '/lists/schain/create'
      fullPath: '/supply/lists/schain/create'
      preLoaderRoute: typeof SupplyListsSchainCreateRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/lists_/rewrite_/create': {
      id: '/supply/lists_/rewrite_/create'
      path: '/lists/rewrite/create'
      fullPath: '/supply/lists/rewrite/create'
      preLoaderRoute: typeof SupplyListsRewriteCreateRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/apps_/edit/$appId': {
      id: '/supply/apps_/edit/$appId'
      path: '/apps/edit/$appId'
      fullPath: '/supply/apps/edit/$appId'
      preLoaderRoute: typeof SupplyAppsEditAppIdRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/p/$publisherId_/reporting/report-explorer': {
      id: '/p/$publisherId_/reporting/report-explorer'
      path: '/p/$publisherId/reporting/report-explorer'
      fullPath: '/p/$publisherId/reporting/report-explorer'
      preLoaderRoute: typeof PPublisherIdReportingReportExplorerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/networks/$networkId/details/overview': {
      id: '/networks/$networkId/details/overview'
      path: '/overview'
      fullPath: '/networks/$networkId/details/overview'
      preLoaderRoute: typeof NetworksNetworkIdDetailsOverviewRouteImport
      parentRoute: typeof NetworksNetworkIdDetailsRoute
    }
    '/demand/partners/edit/$demandPartnerId': {
      id: '/demand/partners/edit/$demandPartnerId'
      path: '/edit/$demandPartnerId'
      fullPath: '/demand/partners/edit/$demandPartnerId'
      preLoaderRoute: typeof DemandPartnersEditDemandPartnerIdRouteImport
      parentRoute: typeof DemandPartnersRoute
    }
    '/demand/partners/$demandPartnerId/details': {
      id: '/demand/partners/$demandPartnerId/details'
      path: '/$demandPartnerId/details'
      fullPath: '/demand/partners/$demandPartnerId/details'
      preLoaderRoute: typeof DemandPartnersDemandPartnerIdDetailsRouteImport
      parentRoute: typeof DemandPartnersRoute
    }
    '/demand/owners/edit/$ownerId': {
      id: '/demand/owners/edit/$ownerId'
      path: '/edit/$ownerId'
      fullPath: '/demand/owners/edit/$ownerId'
      preLoaderRoute: typeof DemandOwnersEditOwnerIdRouteImport
      parentRoute: typeof DemandOwnersRoute
    }
    '/demand/deals/edit/$dealId': {
      id: '/demand/deals/edit/$dealId'
      path: '/edit/$dealId'
      fullPath: '/demand/deals/edit/$dealId'
      preLoaderRoute: typeof DemandDealsEditDealIdRouteImport
      parentRoute: typeof DemandDealsRoute
    }
    '/campaigns/supply/tailored-supply/create': {
      id: '/campaigns/supply/tailored-supply/create'
      path: '/create'
      fullPath: '/campaigns/supply/tailored-supply/create'
      preLoaderRoute: typeof CampaignsSupplyTailoredSupplyCreateRouteImport
      parentRoute: typeof CampaignsSupplyTailoredSupplyRoute
    }
    '/campaigns/creatives_/video_/create': {
      id: '/campaigns/creatives_/video_/create'
      path: '/creatives/video/create'
      fullPath: '/campaigns/creatives/video/create'
      preLoaderRoute: typeof CampaignsCreativesVideoCreateRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/creatives_/display_/create': {
      id: '/campaigns/creatives_/display_/create'
      path: '/creatives/display/create'
      fullPath: '/campaigns/creatives/display/create'
      preLoaderRoute: typeof CampaignsCreativesDisplayCreateRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/campaigns_/overview/$campaignId': {
      id: '/campaigns/campaigns_/overview/$campaignId'
      path: '/campaigns/overview/$campaignId'
      fullPath: '/campaigns/campaigns/overview/$campaignId'
      preLoaderRoute: typeof CampaignsCampaignsOverviewCampaignIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/brands_/$brandId/details': {
      id: '/campaigns/brands_/$brandId/details'
      path: '/brands/$brandId/details'
      fullPath: '/campaigns/brands/$brandId/details'
      preLoaderRoute: typeof CampaignsBrandsBrandIdDetailsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/agencies_/$agencyId/details': {
      id: '/campaigns/agencies_/$agencyId/details'
      path: '/agencies/$agencyId/details'
      fullPath: '/campaigns/agencies/$agencyId/details'
      preLoaderRoute: typeof CampaignsAgenciesAgencyIdDetailsRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/a/$agencyId_/reporting/saved-reports': {
      id: '/a/$agencyId_/reporting/saved-reports'
      path: '/a/$agencyId/reporting/saved-reports'
      fullPath: '/a/$agencyId/reporting/saved-reports'
      preLoaderRoute: typeof AAgencyIdReportingSavedReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$agencyId_/reporting/report-explorer': {
      id: '/a/$agencyId_/reporting/report-explorer'
      path: '/a/$agencyId/reporting/report-explorer'
      fullPath: '/a/$agencyId/reporting/report-explorer'
      preLoaderRoute: typeof AAgencyIdReportingReportExplorerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$agencyId_/campaigns/overview': {
      id: '/a/$agencyId_/campaigns/overview'
      path: '/a/$agencyId/campaigns/overview'
      fullPath: '/a/$agencyId/campaigns/overview'
      preLoaderRoute: typeof AAgencyIdCampaignsOverviewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/$agencyId_/campaigns/$section': {
      id: '/a/$agencyId_/campaigns/$section'
      path: '/a/$agencyId/campaigns/$section'
      fullPath: '/a/$agencyId/campaigns/$section'
      preLoaderRoute: typeof AAgencyIdCampaignsSectionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/supply/publishers_/$publisherId/details/': {
      id: '/supply/publishers_/$publisherId/details/'
      path: '/'
      fullPath: '/supply/publishers/$publisherId/details/'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsIndexRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/demand/partners/$demandPartnerId/details/': {
      id: '/demand/partners/$demandPartnerId/details/'
      path: '/'
      fullPath: '/demand/partners/$demandPartnerId/details/'
      preLoaderRoute: typeof DemandPartnersDemandPartnerIdDetailsIndexRouteImport
      parentRoute: typeof DemandPartnersDemandPartnerIdDetailsRoute
    }
    '/supply/publishers_/$publisherId/details/placements': {
      id: '/supply/publishers_/$publisherId/details/placements'
      path: '/placements'
      fullPath: '/supply/publishers/$publisherId/details/placements'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsPlacementsRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/supply/publishers_/$publisherId/details/overview': {
      id: '/supply/publishers_/$publisherId/details/overview'
      path: '/overview'
      fullPath: '/supply/publishers/$publisherId/details/overview'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsOverviewRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/supply/publishers_/$publisherId/details/domains': {
      id: '/supply/publishers_/$publisherId/details/domains'
      path: '/domains'
      fullPath: '/supply/publishers/$publisherId/details/domains'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsDomainsRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/supply/publishers_/$publisherId/details/apps': {
      id: '/supply/publishers_/$publisherId/details/apps'
      path: '/apps'
      fullPath: '/supply/publishers/$publisherId/details/apps'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsAppsRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/supply/publishers_/$publisherId/details/app-requests': {
      id: '/supply/publishers_/$publisherId/details/app-requests'
      path: '/app-requests'
      fullPath: '/supply/publishers/$publisherId/details/app-requests'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsAppRequestsRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/supply/publishers_/$publisherId/details/a2v': {
      id: '/supply/publishers_/$publisherId/details/a2v'
      path: '/a2v'
      fullPath: '/supply/publishers/$publisherId/details/a2v'
      preLoaderRoute: typeof SupplyPublishersPublisherIdDetailsA2vRouteImport
      parentRoute: typeof SupplyPublishersPublisherIdDetailsRoute
    }
    '/supply/lists_/schain_/edit/$listId': {
      id: '/supply/lists_/schain_/edit/$listId'
      path: '/lists/schain/edit/$listId'
      fullPath: '/supply/lists/schain/edit/$listId'
      preLoaderRoute: typeof SupplyListsSchainEditListIdRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/supply/lists_/rewrite_/edit/$listId': {
      id: '/supply/lists_/rewrite_/edit/$listId'
      path: '/lists/rewrite/edit/$listId'
      fullPath: '/supply/lists/rewrite/edit/$listId'
      preLoaderRoute: typeof SupplyListsRewriteEditListIdRouteImport
      parentRoute: typeof SupplyRoute
    }
    '/demand/partners/$demandPartnerId/details/overview': {
      id: '/demand/partners/$demandPartnerId/details/overview'
      path: '/overview'
      fullPath: '/demand/partners/$demandPartnerId/details/overview'
      preLoaderRoute: typeof DemandPartnersDemandPartnerIdDetailsOverviewRouteImport
      parentRoute: typeof DemandPartnersDemandPartnerIdDetailsRoute
    }
    '/demand/integrations/edit/$demandPartnerId/$integrationId': {
      id: '/demand/integrations/edit/$demandPartnerId/$integrationId'
      path: '/edit/$demandPartnerId/$integrationId'
      fullPath: '/demand/integrations/edit/$demandPartnerId/$integrationId'
      preLoaderRoute: typeof DemandIntegrationsEditDemandPartnerIdIntegrationIdRouteImport
      parentRoute: typeof DemandIntegrationsRoute
    }
    '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId': {
      id: '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId'
      path: '/edit/$tailoredSupplyId'
      fullPath: '/campaigns/supply/tailored-supply/edit/$tailoredSupplyId'
      preLoaderRoute: typeof CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRouteImport
      parentRoute: typeof CampaignsSupplyTailoredSupplyRoute
    }
    '/campaigns/creatives_/video_/edit/$creativeId': {
      id: '/campaigns/creatives_/video_/edit/$creativeId'
      path: '/creatives/video/edit/$creativeId'
      fullPath: '/campaigns/creatives/video/edit/$creativeId'
      preLoaderRoute: typeof CampaignsCreativesVideoEditCreativeIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/campaigns/creatives_/display_/edit/$creativeId': {
      id: '/campaigns/creatives_/display_/edit/$creativeId'
      path: '/creatives/display/edit/$creativeId'
      fullPath: '/campaigns/creatives/display/edit/$creativeId'
      preLoaderRoute: typeof CampaignsCreativesDisplayEditCreativeIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/demand/integrations/$integrationId/demand/$demandPartnerId/details': {
      id: '/demand/integrations/$integrationId/demand/$demandPartnerId/details'
      path: '/$integrationId/demand/$demandPartnerId/details'
      fullPath: '/demand/integrations/$integrationId/demand/$demandPartnerId/details'
      preLoaderRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteImport
      parentRoute: typeof DemandIntegrationsRoute
    }
    '/campaigns/campaigns_/overview/$campaignId_/line-items/create': {
      id: '/campaigns/campaigns_/overview/$campaignId_/line-items/create'
      path: '/campaigns/overview/$campaignId/line-items/create'
      fullPath: '/campaigns/campaigns/overview/$campaignId/line-items/create'
      preLoaderRoute: typeof CampaignsCampaignsOverviewCampaignIdLineItemsCreateRouteImport
      parentRoute: typeof CampaignsRoute
    }
    '/a/$agencyId_/campaigns/brands/$brandId/details': {
      id: '/a/$agencyId_/campaigns/brands/$brandId/details'
      path: '/a/$agencyId/campaigns/brands/$brandId/details'
      fullPath: '/a/$agencyId/campaigns/brands/$brandId/details'
      preLoaderRoute: typeof AAgencyIdCampaignsBrandsBrandIdDetailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demand/integrations/$integrationId/demand/$demandPartnerId/details/': {
      id: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/'
      path: '/'
      fullPath: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/'
      preLoaderRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRouteImport
      parentRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute
    }
    '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements': {
      id: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements'
      path: '/placements'
      fullPath: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/placements'
      preLoaderRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRouteImport
      parentRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute
    }
    '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview': {
      id: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview'
      path: '/overview'
      fullPath: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview'
      preLoaderRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRouteImport
      parentRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute
    }
    '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey': {
      id: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey'
      path: '/journey'
      fullPath: '/demand/integrations/$integrationId/demand/$demandPartnerId/details/journey'
      preLoaderRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRouteImport
      parentRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute
    }
    '/campaigns/campaigns_/overview/$campaignId_/line-items/edit/$lineItemId': {
      id: '/campaigns/campaigns_/overview/$campaignId_/line-items/edit/$lineItemId'
      path: '/campaigns/overview/$campaignId/line-items/edit/$lineItemId'
      fullPath: '/campaigns/campaigns/overview/$campaignId/line-items/edit/$lineItemId'
      preLoaderRoute: typeof CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRouteImport
      parentRoute: typeof CampaignsRoute
    }
  }
}

interface A2vRouteChildren {
  A2vAssetsRoute: typeof A2vAssetsRoute
  A2vNetworkTemplateRoute: typeof A2vNetworkTemplateRoute
  A2vIndexRoute: typeof A2vIndexRoute
}

const A2vRouteChildren: A2vRouteChildren = {
  A2vAssetsRoute: A2vAssetsRoute,
  A2vNetworkTemplateRoute: A2vNetworkTemplateRoute,
  A2vIndexRoute: A2vIndexRoute,
}

const A2vRouteWithChildren = A2vRoute._addFileChildren(A2vRouteChildren)

interface AdminRouteChildren {
  AdminChangelogRoute: typeof AdminChangelogRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminChangelogRoute: AdminChangelogRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface CampaignsSupplyTailoredSupplyRouteChildren {
  CampaignsSupplyTailoredSupplyCreateRoute: typeof CampaignsSupplyTailoredSupplyCreateRoute
  CampaignsSupplyTailoredSupplyIndexRoute: typeof CampaignsSupplyTailoredSupplyIndexRoute
  CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute: typeof CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute
}

const CampaignsSupplyTailoredSupplyRouteChildren: CampaignsSupplyTailoredSupplyRouteChildren =
  {
    CampaignsSupplyTailoredSupplyCreateRoute:
      CampaignsSupplyTailoredSupplyCreateRoute,
    CampaignsSupplyTailoredSupplyIndexRoute:
      CampaignsSupplyTailoredSupplyIndexRoute,
    CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute:
      CampaignsSupplyTailoredSupplyEditTailoredSupplyIdRoute,
  }

const CampaignsSupplyTailoredSupplyRouteWithChildren =
  CampaignsSupplyTailoredSupplyRoute._addFileChildren(
    CampaignsSupplyTailoredSupplyRouteChildren,
  )

interface CampaignsRouteChildren {
  CampaignsAgenciesRoute: typeof CampaignsAgenciesRoute
  CampaignsBrandsRoute: typeof CampaignsBrandsRoute
  CampaignsCampaignsRoute: typeof CampaignsCampaignsRoute
  CampaignsChannelGroupsRoute: typeof CampaignsChannelGroupsRoute
  CampaignsCreativesRoute: typeof CampaignsCreativesRoute
  CampaignsCreativesDisplayRoute: typeof CampaignsCreativesDisplayRoute
  CampaignsCreativesVideoRoute: typeof CampaignsCreativesVideoRoute
  CampaignsSupplyAppsRoute: typeof CampaignsSupplyAppsRoute
  CampaignsSupplyDomainsRoute: typeof CampaignsSupplyDomainsRoute
  CampaignsSupplyTailoredSupplyRoute: typeof CampaignsSupplyTailoredSupplyRouteWithChildren
  CampaignsAgenciesAgencyIdDetailsRoute: typeof CampaignsAgenciesAgencyIdDetailsRoute
  CampaignsBrandsBrandIdDetailsRoute: typeof CampaignsBrandsBrandIdDetailsRoute
  CampaignsCampaignsOverviewCampaignIdRoute: typeof CampaignsCampaignsOverviewCampaignIdRoute
  CampaignsCreativesDisplayCreateRoute: typeof CampaignsCreativesDisplayCreateRoute
  CampaignsCreativesVideoCreateRoute: typeof CampaignsCreativesVideoCreateRoute
  CampaignsCreativesDisplayEditCreativeIdRoute: typeof CampaignsCreativesDisplayEditCreativeIdRoute
  CampaignsCreativesVideoEditCreativeIdRoute: typeof CampaignsCreativesVideoEditCreativeIdRoute
  CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute: typeof CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute
  CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute: typeof CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute
}

const CampaignsRouteChildren: CampaignsRouteChildren = {
  CampaignsAgenciesRoute: CampaignsAgenciesRoute,
  CampaignsBrandsRoute: CampaignsBrandsRoute,
  CampaignsCampaignsRoute: CampaignsCampaignsRoute,
  CampaignsChannelGroupsRoute: CampaignsChannelGroupsRoute,
  CampaignsCreativesRoute: CampaignsCreativesRoute,
  CampaignsCreativesDisplayRoute: CampaignsCreativesDisplayRoute,
  CampaignsCreativesVideoRoute: CampaignsCreativesVideoRoute,
  CampaignsSupplyAppsRoute: CampaignsSupplyAppsRoute,
  CampaignsSupplyDomainsRoute: CampaignsSupplyDomainsRoute,
  CampaignsSupplyTailoredSupplyRoute:
    CampaignsSupplyTailoredSupplyRouteWithChildren,
  CampaignsAgenciesAgencyIdDetailsRoute: CampaignsAgenciesAgencyIdDetailsRoute,
  CampaignsBrandsBrandIdDetailsRoute: CampaignsBrandsBrandIdDetailsRoute,
  CampaignsCampaignsOverviewCampaignIdRoute:
    CampaignsCampaignsOverviewCampaignIdRoute,
  CampaignsCreativesDisplayCreateRoute: CampaignsCreativesDisplayCreateRoute,
  CampaignsCreativesVideoCreateRoute: CampaignsCreativesVideoCreateRoute,
  CampaignsCreativesDisplayEditCreativeIdRoute:
    CampaignsCreativesDisplayEditCreativeIdRoute,
  CampaignsCreativesVideoEditCreativeIdRoute:
    CampaignsCreativesVideoEditCreativeIdRoute,
  CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute:
    CampaignsCampaignsOverviewCampaignIdLineItemsCreateRoute,
  CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute:
    CampaignsCampaignsOverviewCampaignIdLineItemsEditLineItemIdRoute,
}

const CampaignsRouteWithChildren = CampaignsRoute._addFileChildren(
  CampaignsRouteChildren,
)

interface DemandDealsRouteChildren {
  DemandDealsCreateRoute: typeof DemandDealsCreateRoute
  DemandDealsIndexRoute: typeof DemandDealsIndexRoute
  DemandDealsEditDealIdRoute: typeof DemandDealsEditDealIdRoute
}

const DemandDealsRouteChildren: DemandDealsRouteChildren = {
  DemandDealsCreateRoute: DemandDealsCreateRoute,
  DemandDealsIndexRoute: DemandDealsIndexRoute,
  DemandDealsEditDealIdRoute: DemandDealsEditDealIdRoute,
}

const DemandDealsRouteWithChildren = DemandDealsRoute._addFileChildren(
  DemandDealsRouteChildren,
)

interface DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteChildren {
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute
}

const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteChildren: DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteChildren =
  {
    DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute:
      DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsJourneyRoute,
    DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute:
      DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsOverviewRoute,
    DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute:
      DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsPlacementsRoute,
    DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute:
      DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsIndexRoute,
  }

const DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteWithChildren =
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute._addFileChildren(
    DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteChildren,
  )

interface DemandIntegrationsRouteChildren {
  DemandIntegrationsCreateRoute: typeof DemandIntegrationsCreateRoute
  DemandIntegrationsIndexRoute: typeof DemandIntegrationsIndexRoute
  DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute: typeof DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute: typeof DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteWithChildren
}

const DemandIntegrationsRouteChildren: DemandIntegrationsRouteChildren = {
  DemandIntegrationsCreateRoute: DemandIntegrationsCreateRoute,
  DemandIntegrationsIndexRoute: DemandIntegrationsIndexRoute,
  DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute:
    DemandIntegrationsEditDemandPartnerIdIntegrationIdRoute,
  DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRoute:
    DemandIntegrationsIntegrationIdDemandDemandPartnerIdDetailsRouteWithChildren,
}

const DemandIntegrationsRouteWithChildren =
  DemandIntegrationsRoute._addFileChildren(DemandIntegrationsRouteChildren)

interface DemandOwnersRouteChildren {
  DemandOwnersCreateRoute: typeof DemandOwnersCreateRoute
  DemandOwnersIndexRoute: typeof DemandOwnersIndexRoute
  DemandOwnersEditOwnerIdRoute: typeof DemandOwnersEditOwnerIdRoute
}

const DemandOwnersRouteChildren: DemandOwnersRouteChildren = {
  DemandOwnersCreateRoute: DemandOwnersCreateRoute,
  DemandOwnersIndexRoute: DemandOwnersIndexRoute,
  DemandOwnersEditOwnerIdRoute: DemandOwnersEditOwnerIdRoute,
}

const DemandOwnersRouteWithChildren = DemandOwnersRoute._addFileChildren(
  DemandOwnersRouteChildren,
)

interface DemandPartnersDemandPartnerIdDetailsRouteChildren {
  DemandPartnersDemandPartnerIdDetailsOverviewRoute: typeof DemandPartnersDemandPartnerIdDetailsOverviewRoute
  DemandPartnersDemandPartnerIdDetailsIndexRoute: typeof DemandPartnersDemandPartnerIdDetailsIndexRoute
}

const DemandPartnersDemandPartnerIdDetailsRouteChildren: DemandPartnersDemandPartnerIdDetailsRouteChildren =
  {
    DemandPartnersDemandPartnerIdDetailsOverviewRoute:
      DemandPartnersDemandPartnerIdDetailsOverviewRoute,
    DemandPartnersDemandPartnerIdDetailsIndexRoute:
      DemandPartnersDemandPartnerIdDetailsIndexRoute,
  }

const DemandPartnersDemandPartnerIdDetailsRouteWithChildren =
  DemandPartnersDemandPartnerIdDetailsRoute._addFileChildren(
    DemandPartnersDemandPartnerIdDetailsRouteChildren,
  )

interface DemandPartnersRouteChildren {
  DemandPartnersCreateRoute: typeof DemandPartnersCreateRoute
  DemandPartnersIndexRoute: typeof DemandPartnersIndexRoute
  DemandPartnersDemandPartnerIdDetailsRoute: typeof DemandPartnersDemandPartnerIdDetailsRouteWithChildren
  DemandPartnersEditDemandPartnerIdRoute: typeof DemandPartnersEditDemandPartnerIdRoute
}

const DemandPartnersRouteChildren: DemandPartnersRouteChildren = {
  DemandPartnersCreateRoute: DemandPartnersCreateRoute,
  DemandPartnersIndexRoute: DemandPartnersIndexRoute,
  DemandPartnersDemandPartnerIdDetailsRoute:
    DemandPartnersDemandPartnerIdDetailsRouteWithChildren,
  DemandPartnersEditDemandPartnerIdRoute:
    DemandPartnersEditDemandPartnerIdRoute,
}

const DemandPartnersRouteWithChildren = DemandPartnersRoute._addFileChildren(
  DemandPartnersRouteChildren,
)

interface DemandRouteChildren {
  DemandDealsRoute: typeof DemandDealsRouteWithChildren
  DemandIntegrationsRoute: typeof DemandIntegrationsRouteWithChildren
  DemandOwnersRoute: typeof DemandOwnersRouteWithChildren
  DemandPartnersRoute: typeof DemandPartnersRouteWithChildren
  DemandIndexRoute: typeof DemandIndexRoute
}

const DemandRouteChildren: DemandRouteChildren = {
  DemandDealsRoute: DemandDealsRouteWithChildren,
  DemandIntegrationsRoute: DemandIntegrationsRouteWithChildren,
  DemandOwnersRoute: DemandOwnersRouteWithChildren,
  DemandPartnersRoute: DemandPartnersRouteWithChildren,
  DemandIndexRoute: DemandIndexRoute,
}

const DemandRouteWithChildren =
  DemandRoute._addFileChildren(DemandRouteChildren)

interface NetworksNetworkIdDetailsRouteChildren {
  NetworksNetworkIdDetailsOverviewRoute: typeof NetworksNetworkIdDetailsOverviewRoute
  NetworksNetworkIdDetailsIndexRoute: typeof NetworksNetworkIdDetailsIndexRoute
}

const NetworksNetworkIdDetailsRouteChildren: NetworksNetworkIdDetailsRouteChildren =
  {
    NetworksNetworkIdDetailsOverviewRoute:
      NetworksNetworkIdDetailsOverviewRoute,
    NetworksNetworkIdDetailsIndexRoute: NetworksNetworkIdDetailsIndexRoute,
  }

const NetworksNetworkIdDetailsRouteWithChildren =
  NetworksNetworkIdDetailsRoute._addFileChildren(
    NetworksNetworkIdDetailsRouteChildren,
  )

interface NetworksRouteChildren {
  NetworksCreateRoute: typeof NetworksCreateRoute
  NetworksIndexRoute: typeof NetworksIndexRoute
  NetworksNetworkIdDetailsRoute: typeof NetworksNetworkIdDetailsRouteWithChildren
  NetworksEditNetworkIdRoute: typeof NetworksEditNetworkIdRoute
}

const NetworksRouteChildren: NetworksRouteChildren = {
  NetworksCreateRoute: NetworksCreateRoute,
  NetworksIndexRoute: NetworksIndexRoute,
  NetworksNetworkIdDetailsRoute: NetworksNetworkIdDetailsRouteWithChildren,
  NetworksEditNetworkIdRoute: NetworksEditNetworkIdRoute,
}

const NetworksRouteWithChildren = NetworksRoute._addFileChildren(
  NetworksRouteChildren,
)

interface ReportingRouteChildren {
  ReportingNetworkPerformanceRoute: typeof ReportingNetworkPerformanceRoute
  ReportingPerformanceAnalyzerRoute: typeof ReportingPerformanceAnalyzerRoute
  ReportingReportExplorerRoute: typeof ReportingReportExplorerRoute
  ReportingSavedReportsRoute: typeof ReportingSavedReportsRoute
  ReportingIndexRoute: typeof ReportingIndexRoute
  ReportingSavedReportsSharedRoute: typeof ReportingSavedReportsSharedRoute
}

const ReportingRouteChildren: ReportingRouteChildren = {
  ReportingNetworkPerformanceRoute: ReportingNetworkPerformanceRoute,
  ReportingPerformanceAnalyzerRoute: ReportingPerformanceAnalyzerRoute,
  ReportingReportExplorerRoute: ReportingReportExplorerRoute,
  ReportingSavedReportsRoute: ReportingSavedReportsRoute,
  ReportingIndexRoute: ReportingIndexRoute,
  ReportingSavedReportsSharedRoute: ReportingSavedReportsSharedRoute,
}

const ReportingRouteWithChildren = ReportingRoute._addFileChildren(
  ReportingRouteChildren,
)

interface SupplyAdsTxtRouteChildren {
  SupplyAdsTxtAppsRoute: typeof SupplyAdsTxtAppsRoute
  SupplyAdsTxtDomainsRoute: typeof SupplyAdsTxtDomainsRoute
  SupplyAdsTxtRecordsRoute: typeof SupplyAdsTxtRecordsRoute
  SupplyAdsTxtIndexRoute: typeof SupplyAdsTxtIndexRoute
}

const SupplyAdsTxtRouteChildren: SupplyAdsTxtRouteChildren = {
  SupplyAdsTxtAppsRoute: SupplyAdsTxtAppsRoute,
  SupplyAdsTxtDomainsRoute: SupplyAdsTxtDomainsRoute,
  SupplyAdsTxtRecordsRoute: SupplyAdsTxtRecordsRoute,
  SupplyAdsTxtIndexRoute: SupplyAdsTxtIndexRoute,
}

const SupplyAdsTxtRouteWithChildren = SupplyAdsTxtRoute._addFileChildren(
  SupplyAdsTxtRouteChildren,
)

interface SupplyAppsRouteChildren {
  SupplyAppsRequestsRoute: typeof SupplyAppsRequestsRoute
  SupplyAppsIndexRoute: typeof SupplyAppsIndexRoute
}

const SupplyAppsRouteChildren: SupplyAppsRouteChildren = {
  SupplyAppsRequestsRoute: SupplyAppsRequestsRoute,
  SupplyAppsIndexRoute: SupplyAppsIndexRoute,
}

const SupplyAppsRouteWithChildren = SupplyAppsRoute._addFileChildren(
  SupplyAppsRouteChildren,
)

interface SupplyBlockedListRouteChildren {
  SupplyBlockedListCreativesRoute: typeof SupplyBlockedListCreativesRoute
  SupplyBlockedListIndexRoute: typeof SupplyBlockedListIndexRoute
}

const SupplyBlockedListRouteChildren: SupplyBlockedListRouteChildren = {
  SupplyBlockedListCreativesRoute: SupplyBlockedListCreativesRoute,
  SupplyBlockedListIndexRoute: SupplyBlockedListIndexRoute,
}

const SupplyBlockedListRouteWithChildren =
  SupplyBlockedListRoute._addFileChildren(SupplyBlockedListRouteChildren)

interface SupplyListsRouteChildren {
  SupplyListsAllRoute: typeof SupplyListsAllRoute
  SupplyListsRewriteRoute: typeof SupplyListsRewriteRoute
  SupplyListsSchainRoute: typeof SupplyListsSchainRoute
  SupplyListsIndexRoute: typeof SupplyListsIndexRoute
}

const SupplyListsRouteChildren: SupplyListsRouteChildren = {
  SupplyListsAllRoute: SupplyListsAllRoute,
  SupplyListsRewriteRoute: SupplyListsRewriteRoute,
  SupplyListsSchainRoute: SupplyListsSchainRoute,
  SupplyListsIndexRoute: SupplyListsIndexRoute,
}

const SupplyListsRouteWithChildren = SupplyListsRoute._addFileChildren(
  SupplyListsRouteChildren,
)

interface SupplyTailoredSupplyRouteChildren {
  SupplyTailoredSupplyCreateRoute: typeof SupplyTailoredSupplyCreateRoute
  SupplyTailoredSupplyIndexRoute: typeof SupplyTailoredSupplyIndexRoute
}

const SupplyTailoredSupplyRouteChildren: SupplyTailoredSupplyRouteChildren = {
  SupplyTailoredSupplyCreateRoute: SupplyTailoredSupplyCreateRoute,
  SupplyTailoredSupplyIndexRoute: SupplyTailoredSupplyIndexRoute,
}

const SupplyTailoredSupplyRouteWithChildren =
  SupplyTailoredSupplyRoute._addFileChildren(SupplyTailoredSupplyRouteChildren)

interface SupplyPublishersPublisherIdDetailsRouteChildren {
  SupplyPublishersPublisherIdDetailsA2vRoute: typeof SupplyPublishersPublisherIdDetailsA2vRoute
  SupplyPublishersPublisherIdDetailsAppRequestsRoute: typeof SupplyPublishersPublisherIdDetailsAppRequestsRoute
  SupplyPublishersPublisherIdDetailsAppsRoute: typeof SupplyPublishersPublisherIdDetailsAppsRoute
  SupplyPublishersPublisherIdDetailsDomainsRoute: typeof SupplyPublishersPublisherIdDetailsDomainsRoute
  SupplyPublishersPublisherIdDetailsOverviewRoute: typeof SupplyPublishersPublisherIdDetailsOverviewRoute
  SupplyPublishersPublisherIdDetailsPlacementsRoute: typeof SupplyPublishersPublisherIdDetailsPlacementsRoute
  SupplyPublishersPublisherIdDetailsIndexRoute: typeof SupplyPublishersPublisherIdDetailsIndexRoute
}

const SupplyPublishersPublisherIdDetailsRouteChildren: SupplyPublishersPublisherIdDetailsRouteChildren =
  {
    SupplyPublishersPublisherIdDetailsA2vRoute:
      SupplyPublishersPublisherIdDetailsA2vRoute,
    SupplyPublishersPublisherIdDetailsAppRequestsRoute:
      SupplyPublishersPublisherIdDetailsAppRequestsRoute,
    SupplyPublishersPublisherIdDetailsAppsRoute:
      SupplyPublishersPublisherIdDetailsAppsRoute,
    SupplyPublishersPublisherIdDetailsDomainsRoute:
      SupplyPublishersPublisherIdDetailsDomainsRoute,
    SupplyPublishersPublisherIdDetailsOverviewRoute:
      SupplyPublishersPublisherIdDetailsOverviewRoute,
    SupplyPublishersPublisherIdDetailsPlacementsRoute:
      SupplyPublishersPublisherIdDetailsPlacementsRoute,
    SupplyPublishersPublisherIdDetailsIndexRoute:
      SupplyPublishersPublisherIdDetailsIndexRoute,
  }

const SupplyPublishersPublisherIdDetailsRouteWithChildren =
  SupplyPublishersPublisherIdDetailsRoute._addFileChildren(
    SupplyPublishersPublisherIdDetailsRouteChildren,
  )

interface SupplyRouteChildren {
  SupplyAdsTxtRoute: typeof SupplyAdsTxtRouteWithChildren
  SupplyAppsRoute: typeof SupplyAppsRouteWithChildren
  SupplyBlockedListRoute: typeof SupplyBlockedListRouteWithChildren
  SupplyDomainsRoute: typeof SupplyDomainsRoute
  SupplyEndpointGeneratorRoute: typeof SupplyEndpointGeneratorRoute
  SupplyListsRoute: typeof SupplyListsRouteWithChildren
  SupplyPlacementsRoute: typeof SupplyPlacementsRoute
  SupplyPublishersRoute: typeof SupplyPublishersRoute
  SupplyTailoredSupplyRoute: typeof SupplyTailoredSupplyRouteWithChildren
  SupplyIndexRoute: typeof SupplyIndexRoute
  SupplyPublishersCreateRoute: typeof SupplyPublishersCreateRoute
  SupplyAppsEditAppIdRoute: typeof SupplyAppsEditAppIdRoute
  SupplyListsRewriteCreateRoute: typeof SupplyListsRewriteCreateRoute
  SupplyListsSchainCreateRoute: typeof SupplyListsSchainCreateRoute
  SupplyPlacementsCreatePlacementTypeRoute: typeof SupplyPlacementsCreatePlacementTypeRoute
  SupplyPlacementsEditPlacementIdRoute: typeof SupplyPlacementsEditPlacementIdRoute
  SupplyPublishersPublisherIdDetailsRoute: typeof SupplyPublishersPublisherIdDetailsRouteWithChildren
  SupplyPublishersEditPublisherIdRoute: typeof SupplyPublishersEditPublisherIdRoute
  SupplyListsRewriteEditListIdRoute: typeof SupplyListsRewriteEditListIdRoute
  SupplyListsSchainEditListIdRoute: typeof SupplyListsSchainEditListIdRoute
}

const SupplyRouteChildren: SupplyRouteChildren = {
  SupplyAdsTxtRoute: SupplyAdsTxtRouteWithChildren,
  SupplyAppsRoute: SupplyAppsRouteWithChildren,
  SupplyBlockedListRoute: SupplyBlockedListRouteWithChildren,
  SupplyDomainsRoute: SupplyDomainsRoute,
  SupplyEndpointGeneratorRoute: SupplyEndpointGeneratorRoute,
  SupplyListsRoute: SupplyListsRouteWithChildren,
  SupplyPlacementsRoute: SupplyPlacementsRoute,
  SupplyPublishersRoute: SupplyPublishersRoute,
  SupplyTailoredSupplyRoute: SupplyTailoredSupplyRouteWithChildren,
  SupplyIndexRoute: SupplyIndexRoute,
  SupplyPublishersCreateRoute: SupplyPublishersCreateRoute,
  SupplyAppsEditAppIdRoute: SupplyAppsEditAppIdRoute,
  SupplyListsRewriteCreateRoute: SupplyListsRewriteCreateRoute,
  SupplyListsSchainCreateRoute: SupplyListsSchainCreateRoute,
  SupplyPlacementsCreatePlacementTypeRoute:
    SupplyPlacementsCreatePlacementTypeRoute,
  SupplyPlacementsEditPlacementIdRoute: SupplyPlacementsEditPlacementIdRoute,
  SupplyPublishersPublisherIdDetailsRoute:
    SupplyPublishersPublisherIdDetailsRouteWithChildren,
  SupplyPublishersEditPublisherIdRoute: SupplyPublishersEditPublisherIdRoute,
  SupplyListsRewriteEditListIdRoute: SupplyListsRewriteEditListIdRoute,
  SupplyListsSchainEditListIdRoute: SupplyListsSchainEditListIdRoute,
}

const SupplyRouteWithChildren =
  SupplyRoute._addFileChildren(SupplyRouteChildren)

interface TargetingRouteChildren {
  TargetingNewRoute: typeof TargetingNewRoute
  TargetingIndexRoute: typeof TargetingIndexRoute
  TargetingTargetingIdEditRoute: typeof TargetingTargetingIdEditRoute
}

const TargetingRouteChildren: TargetingRouteChildren = {
  TargetingNewRoute: TargetingNewRoute,
  TargetingIndexRoute: TargetingIndexRoute,
  TargetingTargetingIdEditRoute: TargetingTargetingIdEditRoute,
}

const TargetingRouteWithChildren = TargetingRoute._addFileChildren(
  TargetingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  A2vRoute: A2vRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  CampaignsRoute: CampaignsRouteWithChildren,
  DebugRoute: DebugRoute,
  DemandRoute: DemandRouteWithChildren,
  DesignSystemRoute: DesignSystemRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  NetworksRoute: NetworksRouteWithChildren,
  ReportingRoute: ReportingRouteWithChildren,
  ResetPasswordRoute: ResetPasswordRoute,
  SupplyRoute: SupplyRouteWithChildren,
  TargetingRoute: TargetingRouteWithChildren,
  AAgencyIdRoute: AAgencyIdRoute,
  PPublisherIdRoute: PPublisherIdRoute,
  AAgencyIdCampaignsSectionRoute: AAgencyIdCampaignsSectionRoute,
  AAgencyIdCampaignsOverviewRoute: AAgencyIdCampaignsOverviewRoute,
  AAgencyIdReportingReportExplorerRoute: AAgencyIdReportingReportExplorerRoute,
  AAgencyIdReportingSavedReportsRoute: AAgencyIdReportingSavedReportsRoute,
  PPublisherIdReportingReportExplorerRoute:
    PPublisherIdReportingReportExplorerRoute,
  AAgencyIdCampaignsBrandsBrandIdDetailsRoute:
    AAgencyIdCampaignsBrandsBrandIdDetailsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
